<template>
    <!-- // ***************************************************** -->
    <!-- // ***************** CHECK LIST ************************ -->
    <v-container grid-list-md fluid>
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11">
                        <h2>Provisions pour clients douteux et créances irrécouvrables</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                            >
                            </v-btn>
                        </template>
                        <span>Lier un document</span>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-props="props"
                                size="x-small"
                                icon="$oss-chat"
                            >
                            </v-btn>
                        </template>
                        <span>Message</span>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="storeComments()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="
                            disabledBtnGlobalValidation ||
                            loading ||
                            dataLoading ||
                            !accountingPeriod
                        "
                        @click="validateFunction()"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                storeComments('REVIEW');
                            "
                        />
                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                storeComments('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>

                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <template v-else>
                <v-row
                    no-gutters
                    v-if="accountingPeriod && accountingPeriod.closed"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>

                <!-- // ******** GLOBAL AMOUNTS ************************ -->
                <v-card
                    v-if="!customers || !customers.length"
                    elevation="0"
                    class="px-4 my-4"
                    style="background-color: white; border-radius: 25px"
                >
                    <v-card-text class="px-0">
                        <div style="background-color: white; border-radius: 25px" class="pa-4">
                            <v-row class="px-5 py-3">
                                <v-col cols="auto">
                                    <h3>Pas de créances en attente de paiement</h3>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-card>

                <v-card
                    v-else
                    elevation="0"
                    class="px-4 my-4"
                    style="background-color: white; border-radius: 25px"
                >
                    <v-card-text class="px-0">
                        <div style="background-color: white; border-radius: 25px" class="pa-4">
                            <v-row class="px-5 py-3">
                                <v-col cols="auto">
                                    <h3 v-if="resume && resume.resumeDate">
                                        Total créances calculées au : {{ resume.resumeDate }}
                                    </h3>
                                    <h3 v-else>Total créances :</h3>
                                </v-col>
                                <v-col>
                                    <h3 v-if="resume.grossAmountSigned">
                                        T.T.C. :
                                        {{
                                            newCommonFormatCurrency(resume.grossAmountSigned, {
                                                currency: "",
                                                DC: true,
                                            })
                                        }}
                                    </h3>
                                    <h3 v-else>T.T.C. : -</h3>
                                </v-col>
                                <v-col>
                                    <h3 v-if="resume.netAmountSigned">
                                        {{
                                            newCommonFormatCurrency(resume.netAmountSigned, {
                                                currency: "",
                                                DC: true,
                                            })
                                        }}
                                        HT
                                    </h3>
                                    <h3 v-else>- HT</h3>
                                </v-col>
                                <v-col>
                                    <h3 v-if="resume.vatAmountSigned">
                                        T.V.A. :
                                        {{
                                            newCommonFormatCurrency(resume.vatAmountSigned, {
                                                currency: "",
                                                DC: true,
                                            })
                                        }}
                                    </h3>
                                    <h3 v-else>T.V.A. : -</h3>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="1" class="d-flex align-center">Afficher :</v-col>

                                <v-col cols="auto">
                                    <v-switch
                                        v-model="switchPrevious"
                                        :label="`Créances et AAE`"
                                        style="text-center"
                                        class="ml-2"
                                        size="x-small"
                                    />
                                </v-col>

                                <v-col cols="auto">
                                    <v-switch
                                        v-model="switchReceivableAgeing"
                                        :label="`Balance &#xe2;gée`"
                                        style="text-center"
                                        class="ml-2"
                                        size="x-small"
                                    />
                                </v-col>

                                <v-col cols="auto">
                                    <v-switch
                                        v-model="switchValidated"
                                        :label="`Validés`"
                                        style="text-center"
                                        class="ml-2"
                                        size="x-small"
                                    />
                                </v-col>

                                <v-col cols="auto">
                                    <v-switch
                                        v-model="switchIgnored"
                                        :label="`Ignorés`"
                                        style="text-center"
                                        class="ml-2"
                                    />
                                </v-col>

                                <v-col cols="auto">
                                    <v-switch
                                        v-model="switchUnrecoverableLoss"
                                        :label="`Totalité de la créance passée en perte`"
                                        style="text-center"
                                        class="ml-2"
                                    />
                                </v-col>
                            </v-row>

                            <!-- // ********** TABLE OF CUSTOMERS PERIODS ************ -->
                            <v-data-table
                                :headers="computedHeaders"
                                :items="customers"
                                :expanded="expanded"
                                item-key="customer.id"
                                show-expand
                                :sort-by="[{ key: 'customer.name', order: 'asc' }]"
                                :sort-desc="false"
                                :loading="loading"
                                class="table"
                                style="border: 1px #ededed solid"
                            >
                                <!-- :sort-by="['customer', 'netAmountSigned', 'grossAmountSigned', 'creditNotesCumulatedGrossAmountSigned', 'period31', 'period60', 'period90', 'period120', 'period180', 'period365', 'periodMore', 'cumulated4Provisions', 'cumulatedUnrecoverableLoss']" -->

                                <template #no-data>Aucune facture échue</template>

                                <template v-slot:item="props">
                                    <tr v-if="showRow(props.item)">
                                        <!-- // **** Client ******* -->
                                        <td
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                        >
                                            {{ props.item.customer.name }}
                                        </td>

                                        <template v-if="switchPrevious">
                                            <!-- // **** Avoirs à établir déjà émis **** -->
                                            <td
                                                v-if="
                                                    props.item
                                                        .creditNotesCumulatedGrossAmountSigned &&
                                                    props.item.existingCreditNotes
                                                "
                                                style="border-right: 1px solid #dddddd"
                                                class="text-right grey lighten-4"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item
                                                            .creditNotesCumulatedGrossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openCreditNotesList(
                                                            props.item.existingCreditNotes,
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td
                                                v-else
                                                class="text-right grey lighten-4"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                -
                                            </td>

                                            <!-- // **** HT total ******* -->
                                            <td
                                                v-if="props.item.sales.netAmountSigned"
                                                class="text-right grey lighten-4"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.sales.netAmountSigned,
                                                    )
                                                }}
                                            </td>
                                            <td v-else class="text-right grey lighten-4">
                                                {{ newCommonFormatCurrency(0, undefined) }}
                                            </td>

                                            <!-- // **** TVA totale ******* -->
                                            <td
                                                v-if="props.item.sales.vatAmountSigned"
                                                class="text-right grey lighten-4"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.sales.vatAmountSigned,
                                                    )
                                                }}
                                            </td>
                                            <td v-else class="text-right grey lighten-4">
                                                {{ newCommonFormatCurrency(0, undefined) }}
                                            </td>

                                            <!-- // **** Créance TTC totale ******* -->
                                            <td
                                                v-if="
                                                    props.item.sales.grossAmountSigned &&
                                                    props.item.sales.documents
                                                "
                                                style="border-right: 1px solid #dddddd"
                                                class="text-right grey lighten-4"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.sales.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.sales,
                                                            ' : toutes périodes',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td
                                                v-else
                                                class="text-right grey lighten-4"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                {{ newCommonFormatCurrency(0, undefined) }}
                                            </td>
                                        </template>

                                        <!-- // **** Créances nettes des avoirs à établir **** -->
                                        <td
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                            class="text-right"
                                        >
                                            {{
                                                newCommonFormatCurrency(
                                                    props.item.basisGrossAmountSigned,
                                                    undefined,
                                                )
                                            }}
                                        </td>

                                        <!-- // ** switchReceivableAgeing -->
                                        <template v-if="switchReceivableAgeing">
                                            <!-- // **** < 31 jrs ******* -->
                                            <td class="text-right grey lighten-4">
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period31.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period31,
                                                            ' - de 31 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>

                                            <!-- // **** de 32 à 60 jrs ******* -->
                                            <td class="text-right grey lighten-4">
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period60.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period60,
                                                            ' - de 60 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>

                                            <!-- // **** de 61 à 90 jrs ******* -->
                                            <td class="text-right grey lighten-4">
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period90.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period90,
                                                            ' - de 90 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>

                                            <!-- // **** de 91 à 120 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period120 &&
                                                    props.item.period120.grossAmountSigned
                                                "
                                                class="text-right grey lighten-4"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period120.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period120,
                                                            ' - de 120 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-right grey lighten-4">
                                                {{ newCommonFormatCurrency(0, undefined) }}
                                            </td>

                                            <!-- // **** de 121 à 180 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period180 &&
                                                    props.item.period180.grossAmountSigned
                                                "
                                                class="text-right grey lighten-4"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period180.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period180,
                                                            ' - de 180 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-right grey lighten-4">
                                                {{ newCommonFormatCurrency(0, undefined) }}
                                            </td>

                                            <!-- // **** de 181 à 365 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period365 &&
                                                    props.item.period365.grossAmountSigned
                                                "
                                                class="text-right grey lighten-4"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period365.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period365,
                                                            ' - de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-right grey lighten-4">
                                                {{ newCommonFormatCurrency(0, undefined) }}
                                            </td>

                                            <!-- // **** > 365 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.periodMore &&
                                                    props.item.periodMore.grossAmountSigned
                                                "
                                                class="text-right grey lighten-4"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.periodMore.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.periodMore,
                                                            ' + de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td
                                                v-else
                                                class="text-right grey lighten-4"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                {{ newCommonFormatCurrency(0, undefined) }}
                                            </td>
                                        </template>

                                        <!-- // **** cumulated provision ******* -->
                                        <td
                                            v-if="
                                                props.item.doubtfulls &&
                                                props.item.doubtfulls.signedAmounts &&
                                                props.item.doubtfulls.signedAmounts.length &&
                                                props.item.doubtfulls.documents
                                            "
                                            class="text-right"
                                            style="font-weight: bold"
                                        >
                                            {{
                                                newCommonFormatCurrency(
                                                    -props.item.doubtfulls.cumulated4SignedAmount,
                                                    undefined,
                                                )
                                            }}
                                            <v-btn-icon
                                                icon="$remove_red_eye"
                                                @click="
                                                    openProvisionsList(
                                                        props.item.doubtfulls.documents,
                                                        props.item.customer,
                                                    )
                                                "
                                                size="x-small"
                                            />
                                        </td>
                                        <td v-else class="text-right">
                                            {{ newCommonFormatCurrency(0, undefined) }}
                                        </td>

                                        <!-- // **** % provision ******* -->
                                        <td
                                            v-if="
                                                props.item.doubtfulls.cumulated4SignedAmount &&
                                                props.item.basisNetAmountSigned
                                            "
                                            class="text-center"
                                            style="font-weight: bold"
                                        >
                                            {{
                                                (
                                                    (props.item.doubtfulls.cumulated4SignedAmount *
                                                        100) /
                                                    props.item.basisNetAmountSigned
                                                ).toFixed(2)
                                            }}
                                            %
                                        </td>
                                        <td v-else class="text-center">-</td>

                                        <!-- // **** Provisionner le client ******* -->
                                        <td
                                            v-if="
                                                accountingPeriod.closed ||
                                                props.item.validated ||
                                                props.item.ignored
                                            "
                                            class="text-center"
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                        >
                                            <v-btn-icon
                                                icon="$spellcheck"
                                                elevation="0"
                                                disabled
                                                size="x-small"
                                            />
                                        </td>

                                        <td
                                            v-else-if="!showProvision(props.item)"
                                            class="text-center"
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                        >
                                            <v-tooltip :disabled="valid" location="bottom">
                                                <template v-slot:activator="{ props }">
                                                    <div v-bind="props" class="d-inline-block">
                                                        <v-btn-icon
                                                            icon="$spellcheck"
                                                            elevation="0"
                                                            :disabled="!valid"
                                                            size="x-small"
                                                        />
                                                    </div>
                                                </template>
                                                <span>Client passé en perte</span>
                                            </v-tooltip>
                                        </td>

                                        <td
                                            v-else
                                            class="text-center"
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                        >
                                            <v-btn-icon
                                                icon="$spellcheck"
                                                elevation="0"
                                                @click.stop="openProvisionDialog(props.item)"
                                                size="x-small"
                                            />
                                        </td>

                                        <!-- // **** Créance irrécouvrable ******* -->
                                        <td
                                            v-if="
                                                props.item.unrecoverableLoss &&
                                                props.item.unrecoverableLoss.documents &&
                                                props.item.unrecoverableLoss.documents.length
                                            "
                                            class="text-center"
                                            style="font-weight: bold"
                                        >
                                            {{
                                                newCommonFormatCurrency(
                                                    -props.item.unrecoverableLoss
                                                        .cumulated4SignedAmount,
                                                    undefined,
                                                )
                                            }}
                                            <v-btn-icon
                                                icon="$remove_red_eye"
                                                @click="
                                                    openUnrecoverableLossList(
                                                        props.item.unrecoverableLoss.documents,
                                                        props.item.customer,
                                                    )
                                                "
                                                size="x-small"
                                            />
                                        </td>
                                        <td v-else>-</td>

                                        <td
                                            v-if="
                                                accountingPeriod.closed ||
                                                props.item.validated ||
                                                props.item.ignored
                                            "
                                            class="text-center"
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                        >
                                            <v-btn-icon
                                                icon="$spellcheck"
                                                disabled
                                                size="x-small"
                                            />
                                        </td>
                                        <td
                                            v-else-if="!fullUnrecoverableCustomer(props.item)"
                                            class="text-center"
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                        >
                                            <v-btn-icon
                                                icon="$spellcheck"
                                                elevation="0"
                                                @click.stop="
                                                    openUnrecoverableLossDialog(props.item)
                                                "
                                                size="x-small"
                                            />
                                        </td>

                                        <td
                                            v-else
                                            class="text-center"
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                        >
                                            <v-tooltip :disabled="valid2" location="bottom">
                                                <template v-slot:activator="{ props }">
                                                    <div v-bind="props" class="d-inline-block">
                                                        <v-btn
                                                            :disabled="!valid2"
                                                            size="x-small"
                                                            icon="$spellcheck"
                                                        >
                                                        </v-btn>
                                                    </div>
                                                </template>
                                                <span>Client passé en perte</span>
                                            </v-tooltip>
                                        </td>

                                        <!-- // ** comment -->
                                        <td
                                            style="border-left: 1px solid #dddddd; width: 170px"
                                            class="text-center"
                                        >
                                            <v-btn-icon
                                                icon="
                                                    $add_circle_outline
                                                "
                                                v-if="accountingPeriod && accountingPeriod.closed"
                                                disabled
                                                size="x-small"
                                            />
                                            <v-btn-icon
                                                icon="
                                                    $create

                                                    $add_circle_outline
                                                "
                                                v-else
                                                @click="expandComment(props.item)"
                                                size="x-small"
                                            />
                                        </td>

                                        <td>
                                            <!-- // ** {{validatedCustomer}} -->
                                            <v-btn
                                                v-if="accountingPeriod.closed"
                                                rounded
                                                elevation="0"
                                                disabled
                                                size="x-small"
                                            >
                                                -
                                            </v-btn>

                                            <v-btn
                                                v-else-if="
                                                    !props.item.validated && props.item.ignored
                                                "
                                                rounded
                                                elevation="0"
                                                disabled
                                                size="x-small"
                                            >
                                                Valider
                                            </v-btn>

                                            <v-btn
                                                v-else-if="!props.item.validated"
                                                rounded
                                                elevation="0"
                                                @click="validateCustomer(props.item)"
                                                size="x-small"
                                            >
                                                Valider
                                            </v-btn>

                                            <v-btn
                                                v-else
                                                rounded
                                                elevation="0"
                                                @click="validateCustomer(props.item)"
                                                size="x-small"
                                            >
                                                Invalider
                                            </v-btn>
                                        </td>

                                        <td>
                                            <!-- // ** {{ignoredCustomer}} -->
                                            <v-btn
                                                v-if="disabledIgnoreBtn(props.item)"
                                                rounded
                                                elevation="0"
                                                disabled
                                                size="x-small"
                                            >
                                                Ignorer
                                            </v-btn>

                                            <v-btn
                                                v-else-if="!props.item.ignored"
                                                rounded
                                                elevation="0"
                                                @click="ignoreCustomer(props.item)"
                                                size="x-small"
                                            >
                                                Ignorer
                                            </v-btn>

                                            <v-btn
                                                v-else
                                                rounded
                                                elevation="0"
                                                @click="ignoreCustomer(props.item)"
                                                size="x-small"
                                            >
                                                Ne pas ignorer
                                            </v-btn>
                                        </td>

                                        <!-- // ** icon more_vert(ical) with upsert + deleteACR -->
                                        <td
                                            class="text-center"
                                            style="border-left: 1px #ededed solid"
                                        >
                                            <!-- // // start -->
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ props }">
                                                    <v-btn-icon
                                                        icon="$dots_vertical"
                                                        v-bind="props"
                                                        size="x-small"
                                                        class="mx-1"
                                                        color="secondary"
                                                    />
                                                </template>

                                                <v-list>
                                                    <v-list-item
                                                        v-if="accountingPeriod.closed"
                                                        disabled
                                                    >
                                                        <v-list-item-title>
                                                            Supprimer provisions, pertes et
                                                            commentaires de l'exercice
                                                        </v-list-item-title>

                                                        <template v-slot:append>
                                                            <v-icon>$spellcheck</v-icon>
                                                        </template>
                                                    </v-list-item>

                                                    <v-list-item
                                                        v-else-if="
                                                            props.item.globals &&
                                                            props.item.globals.ACRs &&
                                                            props.item.globals.ACRs[0] &&
                                                            props.item.globals.ACRs[0].acrId
                                                        "
                                                        @click="
                                                            deleteAuditCheckResult(
                                                                props.item.globals.ACRs,
                                                            )
                                                        "
                                                    >
                                                        <v-list-item-title>
                                                            Supprimer provisions, pertes et
                                                            commentaires de l'exercice
                                                        </v-list-item-title>
                                                        <template v-slot:append>
                                                            <v-icon size="small">
                                                                $oss-trash
                                                            </v-icon>
                                                        </template>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </template>

                                <template v-slot:expanded-row="{ columns, item }">
                                    <td
                                        :colspan="columns.length"
                                        style="height: 120px; padding-top: 0; margin-top: 0"
                                    >
                                        <v-textarea
                                            outlined
                                            dense
                                            v-model="item.comment"
                                            :disabled="closedPeriod || validated"
                                            style="
                                                margin-right: auto;
                                                margin-left: auto;
                                                padding: 10px;
                                                border: 1px #ededed solid;
                                            "
                                            @update:model-value="addComment(item)"
                                            label="Commentaire"
                                        >
                                        </v-textarea>
                                    </td>
                                </template>
                            </v-data-table>
                        </div>
                    </v-card-text>
                </v-card>

                <!-- // ************** PREVIOUS CREDIT NOTES LIST ************* -->
                <v-card
                    elevation="0"
                    class="px-4 my-4"
                    style="border-radius: 25px"
                    v-if="existingCreditNotes.length > 0"
                    v-show="expand4"
                >
                    <div style="background-color: white; border-radius: 25px">
                        <v-expand-transition>
                            <v-card-text
                                v-if="existingCreditNotes.length > 0"
                                v-show="expand4"
                                class="pa-0"
                            >
                                <v-row class="px-5 pt-3">
                                    <v-col>
                                        <h3>{{ creditNotesCustomer.name }} - Avoirs à établir</h3>
                                    </v-col>
                                </v-row>

                                <v-card-text class="py-4">
                                    <v-data-table
                                        :headers="creditNotesListHeaders"
                                        :items="existingCreditNotes"
                                        :sort-by="[
                                            { key: 'date' },
                                            { key: 'name' },
                                            { key: 'netAmountSigned' },
                                            { key: 'grossAmountSigned' },
                                        ]"
                                        :loading="loading"
                                        class="table"
                                        style="border: 1px #ededed solid"
                                    >
                                        <template #no-data
                                            >Aucun passage en perte irrécouvrable
                                            précédente</template
                                        >

                                        <template v-slot:item="props">
                                            <tr>
                                                <!-- // *** DATE ***  -->
                                                <td v-if="props.item.date" class="text-center">
                                                    {{ formatDate(props.item.date) }}
                                                </td>
                                                <td v-else>-</td>

                                                <!-- // *** Libellé *** -->
                                                <td v-if="props.item.name">
                                                    {{ props.item.name }}
                                                </td>
                                                <td v-else />

                                                <!-- // *** HT *** -->
                                                <template
                                                    v-for="(al, index) in props.item
                                                        .accountingLines"
                                                    :key="index"
                                                >
                                                    <td
                                                        v-if="
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '7',
                                                            ) &&
                                                            al.amountSigned
                                                        "
                                                        :key="index"
                                                        class="text-right"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </td>

                                                    <!-- // *** TVA *** -->
                                                    <td
                                                        v-if="
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '445',
                                                            ) &&
                                                            al.amountSigned &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '7',
                                                            ) &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '41',
                                                            )
                                                        "
                                                        :key="index"
                                                        class="text-right"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </td>
                                                    <td
                                                        v-else-if="
                                                            props.item.accountingLines.length ===
                                                                2 &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '41',
                                                            )
                                                        "
                                                        class="text-right"
                                                    >
                                                        -
                                                    </td>

                                                    <!-- // *** TTC *** -->
                                                    <td
                                                        v-if="
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '41',
                                                            ) &&
                                                            al.amountSigned
                                                        "
                                                        :key="index"
                                                        class="text-right"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </td>
                                                </template>

                                                <!-- // *** openDocument *** -->
                                                <td class="text-center pl-2 py-0">
                                                    <v-btn-icon
                                                        icon="$remove_red_eye"
                                                        @click="openDocument(props.item)"
                                                    />
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card-text>
                        </v-expand-transition>
                    </div>
                </v-card>

                <!-- // ********* DIALOG - CREATE PROVISION ******* -->
                <v-dialog
                    v-if="provisionsDialog"
                    v-model="provisionsDialog"
                    width="90%"
                    class="justify-space-around"
                >
                    <v-card>
                        <v-card-title v-if="selectedCustomer && selectedCustomer.name">
                            Passer une provision pour le client
                            {{ selectedCustomer.name }}
                        </v-card-title>
                        <v-card-title v-else>Pas de client sélectionné</v-card-title>

                        <v-window v-model="step">
                            <!-- // +++++ step 1 - choice of date -->
                            <v-window-item :value="1">
                                <!-- <v-card-text class="py-0">
                                    <oss-date-picker
                                        v-bind:date="selectedDate"
                                        v-bind:minDate="minDate"
                                        v-bind:maxDate="maxDate"
                                        @update:model-value-date="onDatePickerChange2"
                                        class="ml-2"
                                        :textFieldReadOnly="false"
                                        label="Date écriture"
                                    >
                                    </oss-date-picker>
                                </v-card-text> -->

                                <v-divider />

                                <!-- // ** 1 ** -->
                                <!-- // ** Créance totale (base de calcul du pourcentage) :   HT -->
                                <v-card-text class="px-4 py-0">
                                    <v-row v-if="provision6Base" no-gutters class="px-2 py-4">
                                        <v-col align-center>
                                            <h3>
                                                Créance totale (base de calcul du pourcentage) :
                                            </h3>
                                        </v-col>

                                        <v-col cols="3" class="d-flex justify-end align-center">
                                            {{
                                                newCommonFormatCurrency(
                                                    provisionBaseGrossAmountSigned,
                                                    undefined,
                                                )
                                            }}
                                            TTC
                                        </v-col>

                                        <v-col cols="3" class="d-flex justify-end align-center">
                                            {{
                                                newCommonFormatCurrency(-provision6Base, undefined)
                                            }}
                                            HT
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-divider />

                                <!-- // ** 2 ** -->
                                <!-- // ** Provisions précédentes :   %   oss-text-field  -->
                                <v-card-text class="px-4 py-0">
                                    <v-row no-gutters class="px-2 py-4">
                                        <!-- // ** text -->
                                        <v-col
                                            v-if="cumulated4Provisions"
                                            cols="3"
                                            class="d-flex align-center"
                                        >
                                            <h3>Provisions précédentes :</h3>
                                        </v-col>

                                        <v-col v-else cols="3" class="d-flex align-center">
                                            <h3>Pas de provisions précédentes</h3>
                                        </v-col>

                                        <!-- // ** previous % -->
                                        <v-col
                                            v-if="cumulatedPercent"
                                            cols="1"
                                            class="d-flex align-center text-right"
                                        >
                                            {{ cumulatedPercent.toFixed(2) }}%
                                        </v-col>

                                        <v-col
                                            v-else
                                            cols="1"
                                            class="d-flex align-center text-right"
                                        />

                                        <!-- // ** previous HT -->
                                        <v-col
                                            v-if="cumulated4Provisions"
                                            cols="2"
                                            class="d-flex align-center text-center"
                                        >
                                            {{
                                                newCommonFormatCurrency(
                                                    -cumulated4Provisions,
                                                    undefined,
                                                )
                                            }}
                                            HT
                                        </v-col>

                                        <v-col
                                            v-else
                                            cols="2"
                                            class="d-flex align-center text-center"
                                        />

                                        <!-- // ** newPercent -->
                                        <v-col cols="2" class="d-flex align-center">
                                            <oss-text-field
                                                v-model="newPercent"
                                                :suffix="''"
                                                required
                                                :error-messages="errorMessage"
                                                label="Nouveau % global"
                                                :rules="[
                                                    (v) => v >= 0 || 'Min 0',
                                                    (v) => v <= 100 || 'Max 100%',
                                                ]"
                                                :hideDetails="false"
                                                @update:model-value="generateProvisionsDocuments()"
                                            />
                                        </v-col>

                                        <v-spacer />

                                        <!-- // ** new HT -->
                                        <v-col
                                            v-if="new4ProvisionAmount && new4ProvisionAmount != 0"
                                            cols="2"
                                            class="d-flex justify-end align-center"
                                        >
                                            {{
                                                newCommonFormatCurrency(
                                                    -new4ProvisionAmount,
                                                    undefined,
                                                )
                                            }}
                                            HT
                                        </v-col>
                                        <v-col
                                            v-else
                                            cols="2"
                                            class="d-flex justify-end align-center"
                                        />
                                    </v-row>
                                </v-card-text>

                                <v-divider />

                                <!-- // ** 3 ** -->
                                <v-card-text class="px-4 py-0">
                                    <v-row
                                        no-gutters
                                        class="py-4 px-2"
                                        v-if="newPercent || (!newPercent && cumulatedPercent)"
                                    >
                                        <v-col
                                            v-if="delta4ProvisionAmount && cumulated4Provisions"
                                            cols="3"
                                            class="d-flex align-center"
                                        >
                                            <h3>Variation :</h3>
                                        </v-col>

                                        <v-col v-else cols="3" class="d-flex align-center" />

                                        <v-col
                                            v-if="deltaPercent && cumulated4Provisions"
                                            cols="1"
                                            class="d-flex align-center text-right"
                                        >
                                            {{ deltaPercent.toFixed(2) }}%
                                        </v-col>

                                        <v-col v-else cols="1" class="d-flex align-center" />

                                        <v-col cols="2" />

                                        <v-col
                                            v-if="
                                                delta4ProvisionAmount < 0 &&
                                                this.cumulated4Provisions
                                            "
                                            cols="4"
                                            class="d-flex align-center"
                                        >
                                            <h3>Augmentation (Dotation) :</h3>
                                        </v-col>

                                        <v-col
                                            v-else-if="
                                                delta4ProvisionAmount > 0 &&
                                                this.cumulated4Provisions
                                            "
                                            cols="4"
                                            class="d-flex align-center"
                                        >
                                            <h3>Diminution (Reprise) :</h3>
                                        </v-col>

                                        <v-col v-else cols="4" class="d-flex align-center">
                                            <h3>Dotation aux provisions :</h3>
                                        </v-col>

                                        <v-col
                                            v-if="delta4ProvisionAmount"
                                            cols="2"
                                            class="d-flex justify-end align-center"
                                        >
                                            {{
                                                newCommonFormatCurrency(
                                                    -delta4ProvisionAmount,
                                                    undefined,
                                                )
                                            }}
                                            HT
                                        </v-col>

                                        <v-col v-else cols="2" class="d-flex align-center" />
                                    </v-row>
                                </v-card-text>

                                <v-divider />

                                <GetEmptyDocumentsTable
                                    v-if="provisionDocumentsAls && provisionDocumentsAls.length"
                                    :documentAlsCreate="provisionDocumentsAls"
                                    :accountableAccounts="storeAccountableAccounts"
                                />

                                <v-divider />

                                <v-card-actions style="padding-right: 24px; padding-left: 24px">
                                    <v-btn
                                        rounded
                                        class="ma-2"
                                        @click="previous(1)"
                                        :color="'primary'"
                                        size="x-small"
                                    >
                                        Précédent
                                    </v-btn>
                                    <v-spacer />

                                    <v-btn
                                        rounded
                                        class="ma-2"
                                        :color="'primary'"
                                        @click="validateProvision()"
                                        size="x-small"
                                    >
                                        Valider
                                    </v-btn>
                                </v-card-actions>
                            </v-window-item>
                        </v-window>
                    </v-card>
                </v-dialog>

                <!-- // ********* DIALOG - UNRECOVERABLE LOSS ******* -->
                <v-dialog
                    v-if="unrecoverableLossDialog"
                    v-model="unrecoverableLossDialog"
                    width="90%"
                    class="justify-space-around"
                >
                    <v-card>
                        <v-card-title v-if="selectedCustomer && selectedCustomer.name">
                            {{ selectedCustomer.name }} - Passer la créance en perte irrécouvrable
                        </v-card-title>
                        <v-card-title v-else>Pas de client sélectionné</v-card-title>

                        <v-window v-model="stepUL">
                            <!-- // +++++ stepUL 1 - choice of date -->
                            <v-window-item :value="1">
                                <!-- // ** reprises provisions ** -->
                                <v-card-subtitle>
                                    <v-row v-if="provisionReversal">
                                        <v-col>
                                            <h3>Reprise des provisions précédentes :</h3>
                                        </v-col>

                                        <v-col>
                                            {{
                                                newCommonFormatCurrency(
                                                    -provisionReversal,
                                                    undefined,
                                                )
                                            }}
                                            HT
                                        </v-col>

                                        <v-spacer />

                                        <v-col style="text-align: right"
                                            >c/491000 à c/781740
                                        </v-col>
                                    </v-row>

                                    <v-row v-else>
                                        <v-col>Pas de provisions précédentes</v-col>
                                    </v-row>
                                </v-card-subtitle>

                                <!-- // ** tableau HT TVA TTC par % ** -->
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="auto">
                                            <h3>
                                                Détail des écritures non lettrées à passer en perte
                                                irrécouvrable :
                                            </h3>
                                        </v-col>
                                        <v-spacer />
                                        <v-col style="text-align: right">
                                            c/654000 + c4457xx à 411000 {{ selectedCustomer.name }}
                                        </v-col>
                                    </v-row>

                                    <v-switch
                                        v-model="switchManual"
                                        :label="`Modifier les bases HT`"
                                        style="text-center"
                                        class="ml-2"
                                    />

                                    <h3
                                        v-if="
                                            vatBasis00AmountSigned && !manualExportNetAmountSigned
                                        "
                                        style="color: red"
                                    >
                                        HT comptabilisé dans des ODs, restant à repartir parmi le CA
                                        export :
                                        {{
                                            newCommonFormatCurrency(vatBasis00AmountSigned, {
                                                currency: "",
                                                DC: true,
                                            })
                                        }}
                                    </h3>
                                    <h3
                                        v-else-if="
                                            vatBasis00AmountSigned &&
                                            manualExportNetAmountSigned &&
                                            (vatBasis00AmountSigned - manualExportNetAmountSigned <
                                                1 ||
                                                vvatBasis00AmountSigned -
                                                    manualExportNetAmountSigned >
                                                    -1)
                                        "
                                        style="color: red"
                                    >
                                        HT comptabilisé dans des ODs, restant à repartir parmi le CA
                                        export :
                                        {{
                                            newCommonFormatCurrency(
                                                vatBasis00AmountSigned -
                                                    manualExportNetAmountSigned,
                                                { currency: "", DC: true },
                                            )
                                        }}
                                    </h3>

                                    <v-data-table
                                        :headers="
                                            switchManual
                                                ? manualUnrecoverableLossDialogHeaders
                                                : unrecoverableLossDialogHeaders
                                        "
                                        :items="Object.values(vatBasis)"
                                        :sort-by="[{ key: 'sort', order: false }]"
                                        :sort-desc="[false, true]"
                                        hide-default-footer
                                        :loading="loading"
                                        class="table"
                                        style="border: 1px #ededed solid"
                                    >
                                        <template #no-data>Aucune facture échue</template>

                                        <template v-slot:item="props">
                                            <tr>
                                                <!-- // **** vatRate ******* -->
                                                <td
                                                    v-if="props.item.sort === 'HT-a-generic'"
                                                    style="font-weight: bold; color: red"
                                                    class="text-left"
                                                >
                                                    {{ props.item.text }}
                                                </td>
                                                <td
                                                    v-else
                                                    style="font-weight: bold"
                                                    class="text-left"
                                                >
                                                    {{ props.item.text }}
                                                </td>

                                                <!-- // **** HT ******* -->
                                                <td style="font-weight: bold" class="text-right">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            -props.item.amountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>

                                                <!-- // **** previous HT ******* -->
                                                <td
                                                    v-if="props.item.sort === 'HT-a-generic'"
                                                    style="font-weight: bold; color: red"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.previousNetAmountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    v-else
                                                    style="font-weight: bold"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.previousNetAmountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>

                                                <!-- // **** gapAmountSigned ******* -->
                                                <td
                                                    v-if="
                                                        switchManual && props.item.gapAmountSigned
                                                    "
                                                    style="font-weight: bold"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            -props.item.gapAmountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    v-else
                                                    style="font-weight: bold"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            -props.item.gapAmountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>

                                                <!-- // **** manual HT ******* -->
                                                <td
                                                    style="font-weight: bold"
                                                    class="text-right"
                                                    v-if="switchManual"
                                                >
                                                    <!--  // ** :rules - add :hideDetails="false" -->
                                                    <oss-text-field
                                                        v-model="props.item.manualAmount"
                                                        outlined
                                                        dense
                                                        required
                                                        :suffix="'&#x20ac;'"
                                                        :hideDetails="false"
                                                        @change="
                                                            changeManualUnrecoverableLoss(
                                                                props.item,
                                                            )
                                                        "
                                                    >
                                                    </oss-text-field>
                                                </td>

                                                <!-- // **** vatAmountSigned ******* -->
                                                <td
                                                    v-if="
                                                        switchManual &&
                                                        props.item.manualVatAmountSigned
                                                    "
                                                    style="font-weight: bold"
                                                    class="text-right secondary--text"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            -props.item.manualVatAmountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    v-else
                                                    style="font-weight: bold"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            -props.item.vatAmountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>

                                                <!-- // **** grossAmountSigned ******* -->
                                                <td
                                                    v-if="
                                                        switchManual &&
                                                        props.item.manualGrossAmountSigned
                                                    "
                                                    style="font-weight: bold"
                                                    class="text-right secondary--text"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.manualGrossAmountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    v-else
                                                    style="font-weight: bold"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.grossAmountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                        </template>

                                        <template #body.append>
                                            <tr style="font-weight: bold">
                                                <th>Totaux</th>

                                                <!-- // ** amountSigned -->
                                                <th style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                -sumsUnrecoverableLossDialogTable(
                                                                    undefined,
                                                                    "amountSigned",
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>

                                                <!-- // ** previousNetAmountSigned -->
                                                <th style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsUnrecoverableLossDialogTable(
                                                                    undefined,
                                                                    "previousNetAmountSigned",
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>

                                                <!-- // ** gapAmountSigned -->
                                                <th style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                -sumsUnrecoverableLossDialogTable(
                                                                    "gapAmountSigned",
                                                                    undefined,
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>

                                                <!-- // ** manualAmountSigned -->
                                                <th v-if="switchManual" style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                -sumsUnrecoverableLossDialogTable(
                                                                    "manualAmountSigned",
                                                                    undefined,
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>

                                                <!-- // ** manualVatAmountSigned || vatAmountSigned -->
                                                <th v-if="switchManual" style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                -sumsUnrecoverableLossDialogTable(
                                                                    "manualVatAmountSigned",
                                                                    "vatAmountSigned",
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>
                                                <th v-else style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                -sumsUnrecoverableLossDialogTable(
                                                                    undefined,
                                                                    "vatAmountSigned",
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>

                                                <!-- // ** manualGrossAmountSigned || grossAmountSigned -->
                                                <th v-if="switchManual" style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsUnrecoverableLossDialogTable(
                                                                    "manualGrossAmountSigned",
                                                                    "grossAmountSigned",
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>
                                                <th v-else style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsUnrecoverableLossDialogTable(
                                                                    undefined,
                                                                    "grossAmountSigned",
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-card-text>

                                <v-divider />

                                <v-card-actions>
                                    <v-btn
                                        rounded
                                        class="ma-2"
                                        @click="quitUnrecoverableLossDialog"
                                        :color="'primary'"
                                        size="x-small"
                                    >
                                        Annuler
                                    </v-btn>

                                    <v-spacer />

                                    <v-btn
                                        rounded
                                        class="ma-2"
                                        :color="'primary'"
                                        @click="generateUnrecoverableLossDocuments()"
                                        size="x-small"
                                    >
                                        Suivant
                                    </v-btn>
                                </v-card-actions>
                            </v-window-item>

                            <!-- // +++++ stepUL 2 - Verify and validate unrecoverable loss and provision reversal -->
                            <v-window-item :value="2">
                                <v-card-title>
                                    <h2 class="pl-4">Récapitulatif, avant validation</h2>
                                </v-card-title>

                                <GetEmptyDocumentsTable
                                    v-if="provisionDocumentsAls && provisionDocumentsAls.length"
                                    :documentAlsCreate="provisionDocumentsAls"
                                    :accountableAccounts="storeAccountableAccounts"
                                />

                                <GetEmptyDocumentsTable
                                    v-if="
                                        unrecoverableLossDocumentsAls &&
                                        unrecoverableLossDocumentsAls.length
                                    "
                                    :documentAlsCreate="unrecoverableLossDocumentsAls"
                                    :accountableAccounts="storeAccountableAccounts"
                                />

                                <v-divider />

                                <v-card-actions style="padding-right: 24px; padding-left: 24px">
                                    <v-btn
                                        rounded
                                        class="ma-2"
                                        @click="previousUL(1)"
                                        :color="'primary'"
                                        size="x-small"
                                    >
                                        Précédent
                                    </v-btn>
                                    <v-spacer />

                                    <v-btn
                                        rounded
                                        class="ma-2"
                                        :color="'primary'"
                                        v-if="!vatBasis00AmountSigned"
                                        @click="validateUnrecoverableLoss()"
                                        size="x-small"
                                    >
                                        Valider
                                    </v-btn>

                                    <v-btn
                                        rounded
                                        class="ma-2"
                                        :color="'primary'"
                                        v-else
                                        disabled
                                        size="x-small"
                                    >
                                        Valider
                                    </v-btn>
                                </v-card-actions>
                            </v-window-item>
                        </v-window>
                    </v-card>
                </v-dialog>

                <!-- // ************** DOCUMENTS LIST / PERIODS ******************* -->
                <v-expand-transition>
                    <v-card
                        elevation="0"
                        class="px-4 my-4"
                        style="background-color: white; border-radius: 25px"
                        v-if="periodDocuments.length > 0"
                        v-show="expand"
                    >
                        <v-card-text class="px-0">
                            <div style="background-color: white; border-radius: 25px" class="pa-4">
                                <v-card-title
                                    :class="
                                        !$vuetify.display.mobile
                                            ? 'title font-weight-regular justify-space-between'
                                            : 'title font-weight-regular pa-1'
                                    "
                                >
                                    <h3>
                                        {{ periodsCustomer.name }} - Factures échues depuis
                                        {{ selectedPeriod }}
                                    </h3>
                                </v-card-title>

                                <v-data-table
                                    :headers="periodDocumentsHeaders"
                                    :items="periodDocuments"
                                    :sort-by="[
                                        { key: 'date' },
                                        { key: 'netAmountSigned' },
                                        { key: 'grossAmountSigned' },
                                        { key: 'dueDate' },
                                        { key: 'name' },
                                    ]"
                                    :loading="loading"
                                    class="table"
                                    style="border: 1px #ededed solid"
                                >
                                    <template #no-data
                                        >Aucune facture échue sur la période</template
                                    >

                                    <template v-slot:item="props">
                                        <tr>
                                            <!-- // *** Date *** -->
                                            <td v-if="props.item.date" class="text-center">
                                                {{ formatDate(props.item.date) }}
                                            </td>
                                            <td v-else class="text-center">-</td>

                                            <!-- // *** text *** -->
                                            <td v-if="props.item.text" class="text-left">
                                                {{ props.item.text }}
                                            </td>
                                            <td v-else class="text-left">-</td>

                                            <!-- // *** invoiceNumber *** -->
                                            <td v-if="props.item.invoiceNumber" class="text-left">
                                                {{ props.item.invoiceNumber }}
                                            </td>
                                            <td v-else class="text-left">-</td>

                                            <!-- // *** netAmountSigned *** -->
                                            <td v-if="props.item.doc7and6" class="text-right">
                                                {{
                                                    newCommonFormatCurrency(props.item.doc7and6, {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // *** vatAmountSigned *** -->
                                            <td v-if="props.item.doc445" class="text-right">
                                                {{
                                                    newCommonFormatCurrency(props.item.doc445, {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // *** grossAmountSigned *** -->
                                            <td v-if="props.item.doc411" class="text-right">
                                                {{
                                                    newCommonFormatCurrency(props.item.doc411, {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // *** dueDate *** -->
                                            <td v-if="props.item.dueDate" class="text-center">
                                                {{ formatDate(props.item.dueDate) }}
                                            </td>
                                            <td v-else class="text-center">-</td>

                                            <!-- // *** openDocument *** -->
                                            <td class="text-center pl-2 py-0">
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="openDocument(props.item)"
                                                    size="x-small"
                                                />
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-expand-transition>

                <!-- // ************** PREVIOUS PROVISIONS LIST ************* -->
                <v-expand-transition>
                    <v-card
                        elevation="0"
                        class="px-4 my-4"
                        style="background-color: white; border-radius: 25px"
                        v-if="provisionsList.length > 0"
                        v-show="expand2"
                    >
                        <v-card-text class="px-0">
                            <div style="background-color: white; border-radius: 25px" class="pa-4">
                                <v-card-title
                                    :class="
                                        !$vuetify.display.mobile
                                            ? 'title font-weight-regular justify-space-between'
                                            : 'title font-weight-regular pa-1'
                                    "
                                >
                                    <h2>{{ provisionCustomer.name }} - Provisions et reprises</h2>
                                </v-card-title>

                                <v-card-text class="py-0">
                                    <v-data-table
                                        :headers="provisionsListHeaders"
                                        :items="provisionsList"
                                        :sort-by="[
                                            { key: 'date' },
                                            { key: 'name' },
                                            { key: 'netAmountSigned' },
                                        ]"
                                        :loading="loading"
                                        class="table"
                                        style="border: 1px #ededed solid"
                                    >
                                        <template #no-data
                                            >Aucune provision ou reprise précédente</template
                                        >

                                        <template v-slot:item="props">
                                            <tr>
                                                <td v-if="props.item.date" class="text-center">
                                                    {{ formatDate(props.item.date) }}
                                                </td>
                                                <td v-else>-</td>

                                                <td v-if="props.item.name">
                                                    {{ props.item.name }}
                                                </td>
                                                <td
                                                    v-else-if="
                                                        props.item.accountingLines[0].wording
                                                    "
                                                >
                                                    {{ props.item.accountingLines[0].wording }}
                                                </td>
                                                <td v-else />

                                                <td
                                                    v-if="
                                                        props.item.data &&
                                                        props.item.data.accountingLines &&
                                                        props.item.data.accountingLines[0] &&
                                                        props.item.data.accountingLines[0]
                                                            .amountSigned
                                                    "
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.data.accountingLines[0]
                                                                .amountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    v-else-if="
                                                        props.item.accountingLines &&
                                                        props.item.accountingLines[0] &&
                                                        props.item.accountingLines[0].amountSigned
                                                    "
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.accountingLines[0]
                                                                .amountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td v-else class="text-right">
                                                    {{ newCommonFormatCurrency(0, undefined) }}
                                                </td>

                                                <!-- // *** Voir le document *** -->
                                                <td class="text-center pl-2 py-0">
                                                    <v-btn-icon
                                                        icon="$remove_red_eye"
                                                        @click="openDocument(props.item)"
                                                        size="x-small"
                                                    />
                                                </td>
                                            </tr>
                                        </template>

                                        <template #body.append>
                                            <tr style="font-weight: bold">
                                                <th />
                                                <th style="text-align: right; font-weight: bold">
                                                    SOLDE
                                                </th>
                                                <th style="text-align: right; font-weight: bold">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsProvisionsTable(),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-expand-transition>

                <!-- // ************** PREVIOUS UNRECOVERABLE LOSS LIST ************* -->
                <v-expand-transition>
                    <v-card
                        elevation="0"
                        class="px-4 my-4"
                        style="background-color: white; border-radius: 25px"
                        v-if="unrecoverableLossList.length > 0"
                        v-show="expand3"
                    >
                        <v-card-text class="px-0">
                            <div style="background-color: white; border-radius: 25px" class="pa-4">
                                <v-card-title
                                    :class="
                                        !$vuetify.display.mobile
                                            ? 'title font-weight-regular justify-space-between'
                                            : 'title font-weight-regular pa-1'
                                    "
                                >
                                    <h2>Passages en pertes irrécouvrables précédents</h2>
                                </v-card-title>

                                <v-card-text class="py-0">
                                    <v-data-table
                                        :headers="unrecoverableLossListHeaders"
                                        :items="unrecoverableLossList"
                                        :loading="loading"
                                        class="table"
                                        style="border: 1px #ededed solid"
                                    >
                                        <template #no-data
                                            >Aucun passage en perte irrécouvrable
                                            précédente</template
                                        >

                                        <template v-slot:item="props">
                                            <tr>
                                                <!-- // ** date -->
                                                <td v-if="props.item.date" class="text-left">
                                                    {{ formatDate(props.item.date) }}
                                                    <!-- {{props.item}} -->
                                                </td>
                                                <td v-else>-</td>

                                                <!-- // ** name -->
                                                <td v-if="props.item.name">
                                                    {{ props.item.name }}
                                                </td>
                                                <td v-else />

                                                <!-- // ** netAmountSigned -->
                                                <td
                                                    v-if="props.item.unrecoverableLossNetAmount"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.unrecoverableLossNetAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td v-else>
                                                    {{ newCommonFormatCurrency(0, undefined) }}
                                                </td>

                                                <td
                                                    v-if="props.item.unrecoverableLossVatAmount"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.unrecoverableLossVatAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td v-else>
                                                    {{ newCommonFormatCurrency(0, undefined) }}
                                                </td>

                                                <td
                                                    v-if="props.item.unrecoverableLossGrossAmount"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            -props.item
                                                                .unrecoverableLossGrossAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td v-else>
                                                    {{ newCommonFormatCurrency(0, undefined) }}
                                                </td>

                                                <!-- // *** Voir le document *** -->
                                                <td class="text-center pl-2 py-0">
                                                    <v-btn-icon
                                                        icon="$remove_red_eye"
                                                        @click="openDocument(props.item)"
                                                        size="x-small"
                                                    />
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-expand-transition>

                <!-- // ++ resume auto -->
                <v-card
                    v-if="customers && customers.length"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <!-- // ** title ************** -->
                        <!-- <v-col cols="11" class="subtitle-2"> -->
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Synthèse</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <!-- // ** icons *************** -->
                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            commentsExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        @click="commentsExpand = !commentsExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                        size="x-small"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-expand-transition no-gutters>
                        <div v-show="commentsExpand" no-gutters>
                            <v-card-text v-if="!comments || !comments.length" class="px-4">
                                Aucun commentaire saisi
                            </v-card-text>

                            <v-card-text
                                v-else
                                v-for="(comment, index) in comments"
                                :key="index"
                                class="px-4"
                            >
                                <h3 class="text-uppercase pb-1">{{ comment.title }}</h3>
                                <div
                                    v-for="(commentLine, ic) in toArray(comment.text)"
                                    :key="ic"
                                    class="mb-0 px-0"
                                >
                                    <p class="mb-0">{{ commentLine }}</p>
                                </div>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- // ** connectedDocuments -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- // ** results -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <!-- // ++ longComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires détaillés</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <!-- // ** icons *************** -->
                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            longCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="longCommentExpand = !longCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                        size="x-small"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="longCommentExpand" transition="longCommentExpand">
                        <!-- <v-expand-transition no-gutters v-show="longCommentExpand"> -->
                        <v-card-text class="px-4">
                            <v-textarea
                                v-model="longComment"
                                :disabled="closedPeriod || validated"
                                auto-grow
                                style="border: 1px #ededed solid"
                                outlined
                            />
                        </v-card-text>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                >
                                    <v-spacer />

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod"
                                        disabled
                                        rounded
                                        class="btn btn_blue"
                                        size="small"
                                    >
                                        Enregistrer les commentaires
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="storeComments()"
                                        size="small"
                                    >
                                        Enregistrer les commentaires
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** shortComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <!-- // ** title ************** -->
                        <!-- <v-col cols="11" class="subtitle-2"> -->
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires synthétiques</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <!-- // ** icons *************** -->
                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="shortCommentExpand = !shortCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                        size="x-small"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="shortCommentExpand" transition="shortCommentExpand">
                        <v-card-text class="px-4">
                            <v-textarea
                                v-model="shortComment"
                                :disabled="closedPeriod || validated"
                                auto-grow
                                style="border: 1px #ededed solid"
                                outlined
                            />
                        </v-card-text>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                >
                                    <v-spacer />

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod"
                                        disabled
                                        rounded
                                        class="btn btn_blue"
                                        size="small"
                                    >
                                        Enregistrer les commentaires
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="storeComments()"
                                        size="small"
                                    >
                                        Enregistrer les commentaires
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ******** GENERAL LEDGER ************************ -->
                <!-- // ** 411 detailled -->
                <v-card
                    v-show="show411NL || show411NLNextPeriod"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Balance - Grand livre c/411</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand411
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="generalLedgerExpand411 = !generalLedgerExpand411"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                        size="x-small"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-show="generalLedgerExpand411" transition="expand">
                        <v-card
                            v-for="(period, x) in periods"
                            :key="x"
                            style="background-color: white; border-radius: 25px; padding: 10px"
                            class="my-5"
                        >
                            <v-card-title v-if="period.period === 'N'">
                                Solde {{ period.period }} :
                                {{
                                    newCommonFormatCurrency(totalBalance411NL, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </v-card-title>

                            <v-card-title v-else>
                                Solde {{ period.period }} :
                                {{
                                    newCommonFormatCurrency(totalBalance411NLNextPeriod, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </v-card-title>

                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <GeneralLedger
                                            :companyId="companyId"
                                            :accountingPeriodId="period.id"
                                            :thirdPartyType="'411'"
                                            :inNm1="false"
                                            @query-done="period.onQueryDone"
                                            ref="generalLedger"
                                            :enableAuditedAccountableAccounts="true"
                                        />
                                        <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>

                <!-- // ** 416 4198 44587 491 654 68174 -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 v-if="auditItems.accountableAccountsRoot.length" class="pl-4">
                                    Grand livre c/{{
                                        getTextFromStringArray(auditItems.accountableAccountsRoot)
                                    }}
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="generalLedgerExpand = !generalLedgerExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                        size="x-small"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-show="generalLedgerExpand" transition="expand">
                        <v-card
                            v-for="(period, y) in periods"
                            :key="y"
                            style="background-color: white; border-radius: 25px; padding: 10px"
                            class="my-5"
                        >
                            <v-card-title v-if="period.period === 'N'">
                                Solde {{ period.period }} :
                                {{
                                    newCommonFormatCurrency(totalBalance4198NL, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </v-card-title>

                            <v-card-title v-else>
                                Solde {{ period.period }} :
                                {{
                                    newCommonFormatCurrency(totalBalance4198NLNextPeriod, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </v-card-title>

                            <v-card-text>
                                <!-- // // switchs generalLedger -->
                                <!-- <v-row no-gutters>
                                    <v-col>
                                        <v-switch inset v-model="withoutLettering" :label="'Cacher les éléments léttrés'" class="ml-2"></v-switch>
                                    </v-col>
                                    <v-col>
                                        <v-switch inset v-model="withoutBank" :label="'Cacher la trésorerie'" class="ml-2"></v-switch>
                                    </v-col>
                                    <v-col>
                                        <v-switch inset v-model="withoutDocument" :label="'Cacher les justificatifs'" class="ml-2"></v-switch>
                                    </v-col>
                                </v-row> -->

                                <v-row>
                                    <v-col>
                                        <GeneralLedger
                                            :companyId="companyId"
                                            :accountingPeriodId="period.id"
                                            :accountableAccountFilter="
                                                auditItems.accountableAccountsRoot
                                            "
                                            :inNm1="false"
                                            @query-done="period.onQueryDone2"
                                        />
                                        <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                    </v-col>
                                </v-row>

                                <!-- // ** OD -->
                                <v-row>
                                    <v-col style="padding-bottom: 0">
                                        <v-card-title
                                            style="
                                                padding-top: 20px;
                                                padding-bottom: 0;
                                                padding-left: 0;
                                            "
                                        >
                                            <v-spacer />

                                            <v-btn
                                                v-if="closedPeriod"
                                                rounded
                                                disabled
                                                size="x-small"
                                            >
                                                OD
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                rounded
                                                class="btn btn_blue"
                                                @click="
                                                    createAdjustmentsData();
                                                    miscellanousOperationData = undefined;
                                                    miscellaneousOperationDialog = true;
                                                "
                                                size="x-small"
                                            >
                                                OD
                                            </v-btn>
                                        </v-card-title>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <br />
                        </v-card>
                    </v-card-text>
                </v-card>
                <oss-dialog
                    v-if="displayActivityDialog"
                    v-model="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    min-width="60vw"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>
                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-if="dialogAuditCheckDocumentsManager"
                    v-model="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { isEmpty, cloneDeep } from "lodash";

import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getTextFromStringArray } from "../../../../backend/src/common/audit/auditFunctions";
import { getEmptyDocument } from "../../services/documentServices";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";

// //////////////////// APOLLO ////////////////////////
import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";

import GeneralLedger from "../GeneralLedger2.vue";
import { CheckBase } from "./CheckBase";
import GetEmptyDocumentsTable from "./GetEmptyDocumentsTable.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import Chat from "../chat/Chat.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import { getDBFormattedDate } from "@/services/dateServices";
import { getConnectAccountableAccount } from "../../services/accountableAccountServices";
import { getVatAAs } from "../../services/vatServices";
import { getAANameFromVatRate } from "../../../../backend/src/common/vat/vatServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        GeneralLedger,
        GetEmptyDocumentsTable,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
        // AccountingItemEdition
    },
})
export class CheckDoubtfullAccounts extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) documentId: string;

    loading: boolean = false;
    dataLoading: boolean = true;
    valid: boolean = false;
    valid2: boolean = false;

    dialogAuditCheckDocumentsManager: boolean = false;

    // show: boolean = false

    auditCheckResultId: string = "";
    auditCheckResult: any = null;

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    expand: boolean = false;
    expand2: boolean = false;
    expand3: boolean = false;
    expand4: boolean = false;
    expanded: Array<any> = [];
    commentsExpand: boolean = false;
    longCommentExpand: boolean = false;
    shortCommentExpand: boolean = false;

    validated: boolean = false;

    generalLedgerExpand: boolean = false;
    generalLedgerExpand411: boolean = false;
    showGeneralLedger: boolean = false;
    showGeneralLedger411: boolean = false;

    show411NL: boolean = false;
    show411NLNextPeriod: boolean = false;
    show4198NL: boolean = false;
    show4198NLNextPeriod: boolean = false;

    refreshGeneralLedger: string = "All";
    refreshGeneralLedger411: string = "411";

    company: any = {};
    withAccountingPeriod: boolean = false;
    periodYear: string = "";

    firstOpenPeriodStart: string = "";
    lastOpenPeriodEnd: string = "";
    nextAccountingPeriod: any = {};
    periods: Array<any> = [];

    // ** documents
    documents: Array<any> = [];
    data: Array<any> = [];

    alreadyLinkedDoc: boolean = false;

    // searchCustomer = ""

    // ** customers
    selectedCustomer: any = {};
    switchPrevious: boolean = false;
    switchReceivableAgeing: boolean = false;
    switchValidated: boolean = true;
    switchIgnored: boolean = true;
    switchUnrecoverableLoss: boolean = true;

    // ** dialogs
    provisionsDialog: boolean = false;
    unrecoverableLossDialog: boolean = false;
    miscellaneousOperationDialog: boolean = false;

    // ** generalLedger
    totalBalance411NL: number = 0;
    totalBalance411NLNextPeriod: Number = 0;
    totalBalance4198NL: Number = 0;
    totalBalance4198NLNextPeriod: Number = 0;

    // * dates
    selectedDate: any = {};

    minDate: string = "";
    maxDate: string = "";

    // * creditNotes
    existingCreditNotes: Array<any> = [];

    // * sales documents
    invoicesToProvision: Array<any> = [];
    invoiceNumber: string = "";
    periodDocuments: Array<any> = [];
    selectedPeriod: string = "";
    periodsCustomer: any = {};

    // ** provisions
    provisionCustomer: any = {};
    // * percent
    cumulatedPercent: number = 0.0;
    newPercent: number = 0.0;
    deltaPercent: number = 0.0;
    // * amounts
    provision6Base: number = 0.0;
    provisionBaseGrossAmountSigned: number = 0.0;

    cumulated4Provisions: number = 0.0;
    new4ProvisionAmount: number = 0.0;
    delta4ProvisionAmount: number = 0.0;
    provisionReversal: number = 0.0;
    provisionsList: any = {};
    provisionDocumentsAls: Array<any> = [];

    // ** unrecoverableLoss
    unrecoverableLossCustomer: any = {};
    unrecoverableLossNetAmount: number = 0.0;
    unrecoverableLossVatAmount: number = 0.0;
    unrecoverableLossGrossAmount: number = 0.0;
    unrecoverableLossList: Array<any> = [];
    unrecoverableLossDocumentsAls: Array<any> = [];
    switchManual: boolean = false;
    // othersVatBasis: number = 0.0
    vatBasis00AmountSigned: number = 0.0;
    manualExportNetAmountSigned: number = 0;

    storeAccountableAccounts: Array<any> = [];

    vatAAs: any[] = [];

    defaultVatBasis: any = {
        "02": {
            accountableAccountName: "445702",
            sort: "DOM02",
            text: "2,1% (DOM TOM)",
            previousNetAmountSigned: 0,
            amountSigned: 0,
            vatRate: 2.1,
            vatAmountSigned: 0,
            grossAmountSigned: 0,
            manualAmount: 0,
            manualAmountSigned: 0,
            manualVatAmountSigned: 0,
            manualGrossAmountSigned: 0,
            gapAmountSigned: 0,
        },
        "05": {
            accountableAccountName: "445705",
            sort: "05",
            text: "5,5%",
            previousNetAmountSigned: 0,
            amountSigned: 0,
            vatRate: 5.5,
            vatAmountSigned: 0,
            grossAmountSigned: 0,
            manualAmount: 0,
            manualAmountSigned: 0,
            manualVatAmountSigned: 0,
            manualGrossAmountSigned: 0,
            gapAmountSigned: 0,
        },
        "08": {
            accountableAccountName: "445708",
            sort: "DOM08",
            text: "8,5% (DOM TOM)",
            previousNetAmountSigned: 0,
            amountSigned: 0,
            vatRate: 8.5,
            vatAmountSigned: 0,
            grossAmountSigned: 0,
            manualAmount: 0,
            manualAmountSigned: 0,
            manualVatAmountSigned: 0,
            manualGrossAmountSigned: 0,
            gapAmountSigned: 0,
        },
        "10": {
            accountableAccountName: "445710",
            sort: "10",
            text: "10%",
            previousNetAmountSigned: 0,
            amountSigned: 0,
            vatRate: 10,
            vatAmountSigned: 0,
            grossAmountSigned: 0,
            manualAmount: 0,
            manualAmountSigned: 0,
            manualVatAmountSigned: 0,
            manualGrossAmountSigned: 0,
            gapAmountSigned: 0,
        },
        "20": {
            accountableAccountName: "445720",
            sort: "20",
            text: "20%",
            previousNetAmountSigned: 0,
            amountSigned: 0,
            vatRate: 20,
            vatAmountSigned: 0,
            grossAmountSigned: 0,
            manualAmount: 0,
            manualAmountSigned: 0,
            manualVatAmountSigned: 0,
            manualGrossAmountSigned: 0,
            gapAmountSigned: 0,
        },
        "30": {
            accountableAccountName: "",
            sort: "HT-Intracom",
            text: "Intracom",
            previousNetAmountSigned: 0,
            amountSigned: 0,
            vatRate: 0,
            vatAmountSigned: 0,
            grossAmountSigned: 0,
            manualAmount: 0,
            manualAmountSigned: 0,
            manualVatAmountSigned: 0,
            manualGrossAmountSigned: 0,
            gapAmountSigned: 0,
        },
        "80": {
            accountableAccountName: "",
            sort: "HT-Export",
            text: "Export",
            previousNetAmountSigned: 0,
            amountSigned: 0,
            vatRate: 0,
            vatAmountSigned: 0,
            grossAmountSigned: 0,
            manualAmount: 0,
            manualAmountSigned: 0,
            manualVatAmountSigned: 0,
            manualGrossAmountSigned: 0,
            gapAmountSigned: 0,
        },
        "90": {
            accountableAccountName: "",
            sort: "HT-Autoliquidation",
            text: "Autoliquidation",
            previousNetAmountSigned: 0,
            amountSigned: 0,
            vatRate: 0,
            vatAmountSigned: 0,
            grossAmountSigned: 0,
            manualAmount: 0,
            manualAmountSigned: 0,
            manualVatAmountSigned: 0,
            manualGrossAmountSigned: 0,
            gapAmountSigned: 0,
        },
    };

    vatBasis: Array<any> = JSON.parse(JSON.stringify(this.defaultVatBasis));

    // ** acr
    acr: any = {};
    customerPeriodAcrKey: string = "";
    validatedCustomer: boolean = false;
    ignoredCustomer: boolean = false;
    comments: Array<any> = [];
    longComment: string = "";
    shortComment: string = "";

    // get selectedCompany() {
    //     return this.$store.state.selected_company;
    // }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    // auditCheckKey: string = "k0WcnJvR7bjs1cDvpQ1qjpHnP";

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    getTextFromStringArray(array: Array<string>) {
        return getTextFromStringArray(array);
    }

    fullUnrecoverableCustomer(customer6) {
        if (
            (!customer6.basisGrossAmountSigned ||
                Math.abs(customer6.basisGrossAmountSigned) < 1e-3) &&
            customer6.unrecoverableLoss.cumulated4SignedAmount
        ) {
            return true;
        }
        return false;
    }

    disabledIgnoreBtn(customer7) {
        if (this.accountingPeriod?.closed) {
            return true;
        }

        if (customer7.validated && !customer7.ignored) {
            return true;
        }

        if (this.fullUnrecoverableCustomer(customer7)) {
            return true;
        }

        return false;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    // ********** HEADERS - DUES SALES-INVOICES ***********
    doubtfullAccountsHeaders: Array<any> = [
        {
            text: "Client",
            value: "customer",
            align: "left",
            sortable: true,
        },
        {
            text: "AAE TTC déjà émis",
            value: "creditNotesCumulatedGrossAmountSigned",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "HT",
            value: "netAmountSigned",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "TVA",
            value: "vatAmountSigned",
            align: "right",
            sortable: false,
            class: "text-right grey lighten-4",
        },
        {
            text: "Créance TTC",
            value: "grossAmountSigned",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "Créance nette TTC",
            value: "basisGrossAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            text: "< 31 jrs",
            value: "period31",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "de 32 à 60 jrs",
            value: "period60",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "de 61 à 90 jrs",
            value: "period90",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "de 91 à 120 jrs",
            value: "period120",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "de 121 à 180 jrs",
            value: "period180",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "de 181 à 365 jrs",
            value: "period365",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "> 365 jrs",
            value: "periodMore",
            align: "right",
            sortable: true,
            class: "text-right grey lighten-4",
        },
        {
            text: "Provisions H.T.",
            value: "cumulated4Provisions",
            align: "right",
            sortable: true,
        },
        {
            text: "%",
            value: "cumulated4Provisions",
            align: "center",
            sortable: false,
        },
        {
            text: "Provisionner le client",
            value: "",
            align: "center",
            sortable: false,
        },
        {
            text: "Créance irrécouvrable TTC",
            value: "cumulated4SignedAmount",
            align: "center",
            sortable: true,
        },
        {
            text: "",
            value: "",
            align: "center",
            sortable: false,
        },
        // {
        //     text: "",
        //     value: "",
        //     align: "center",
        //     sortable: false
        // },
        {
            text: "Commentaire",
            value: "data-table-expand",
            align: "center",
            sortable: false,
        },
        {
            text: "Valider",
            value: "",
            align: "center",
            sortable: true,
        },
        {
            text: "Ignorer",
            value: "",
            align: "center",
            sortable: true,
        },
        {
            text: "",
            value: "",
            align: "center",
            sortable: true,
        },
    ];

    // ********** HEADERS - LIST OF PREVIOUS CREDIT NOTES ***********
    creditNotesListHeaders: Array<any> = [
        {
            title: "Date avoir",
            value: "date",
            align: "center",
            sortable: true,
        },
        {
            title: "Libellé",
            value: "name",
            align: "left",
            sortable: true,
        },
        {
            title: "HT",
            value: "netAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA",
            value: "vatAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "grossAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "Voir",
            value: "",
            align: "center",
            sortable: true,
        },
    ];

    // ********** HEADERS - LIST OF SALES-INVOICES / DUE PERIOD ***********
    periodDocumentsHeaders: Array<any> = [
        {
            title: "Date",
            value: "date",
            align: "center",
            sortable: true,
        },
        {
            title: "Libellé",
            value: "name",
            align: "left",
            sortable: true,
        },
        {
            title: "N. facture",
            value: "invoiceNumber",
            align: "left",
            sortable: true,
        },
        {
            title: "HT",
            value: "netAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA",
            value: "vatAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "grossAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Echéance",
            value: "dueDate",
            align: "center",
            sortable: true,
        },
        {
            title: "Voir le document",
            value: "",
            align: "center",
            sortable: true,
        },
    ];

    // ********** HEADERS - LIST OF PREVIOUS PROVISIONS ***********
    provisionsListHeaders: Array<any> = [
        {
            title: "Date",
            value: "date",
            align: "center",
            sortable: true,
        },
        {
            title: "Libellé",
            value: "name",
            align: "left",
            sortable: true,
        },
        {
            title: "HT",
            value: "netAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Voir le document",
            value: "",
            align: "center",
            sortable: true,
        },
    ];

    // ********** HEADERS - LIST OF PREVIOUS UNRECOVERABLES LOSS ***********
    unrecoverableLossListHeaders: Array<any> = [
        {
            title: "Date",
            value: "date",
            align: "left",
            sortable: true,
        },
        {
            title: "Libellé",
            value: "name",
            align: "left",
            sortable: true,
        },
        {
            title: "Base HT",
            value: "unrecoverableLossNetAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA",
            value: "unrecoverableLossVatAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "unrecoverableLossGrossAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "Voir le document",
            value: "",
            align: "center",
            sortable: true,
        },
    ];

    // ********** HEADERS - COMPUTE UNRECOVERABLES LOSS DIALOG ***********
    unrecoverableLossDialogHeaders: Array<any> = [
        {
            title: "TVA %",
            value: "Object.keys(vatBasis).text",
            align: "left",
            sortable: true,
        },
        {
            title: "Base HT",
            value: "Object.keys(vatBasis).amountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Pertes déjà comptabilisées HT",
            value: "Object.keys(vatBasis).previousNetAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Écart base HT",
            value: "Object.keys(vatBasis).gapAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA",
            value: "Object.keys(vatBasis).vatAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "Object.keys(vatBasis).grossAmountSigned",
            align: "right",
            sortable: true,
        },
    ];

    manualUnrecoverableLossDialogHeaders: Array<any> = [
        {
            title: "TVA %",
            value: "Object.keys(vatBasis).text",
            align: "left",
            sortable: true,
        },
        {
            title: "Base HT",
            value: "Object.keys(vatBasis).amountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Pertes déjà comptabilisées",
            value: "Object.keys(vatBasis).previousNetAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Écart base HT",
            value: "Object.keys(vatBasis).gapAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Base HT manuelle",
            value: "Object.keys(vatBasis).manualAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA",
            value: "Object.keys(vatBasis).vatAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "Object.keys(vatBasis).grossAmountSigned",
            align: "right",
            sortable: true,
        },
    ];

    createDocumentsHeaders: Array<any> = [
        {
            text: "Date",
            value: "date",
            align: "right",
            sortable: true,
        },
        {
            text: "Compte",
            value: "name",
            align: "right",
            sortable: true,
        },
        {
            text: "Libéllé",
            value: "wording",
            align: "right",
            sortable: true,
        },
        {
            text: "Débit",
            value: "amountSigned",
            align: "right",
            sortable: true,
        },
        {
            text: "Credit",
            value: "amountSigned",
            align: "right",
            sortable: true,
        },
    ];

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();

        if (this.$store.state.accountableAccountTable.accountableAccounts) {
            this.storeAccountableAccounts =
                this.$store.state.accountableAccountTable?.accountableAccounts;
        }
    }

    afterAccountingPeriodFound() {
        if (this.accountingPeriodId && this.accountingPeriod) {
            this.periods.push({
                period: "N",
                id: this.accountingPeriodId,
                onQueryDone: (data) => {
                    this.onQueryDone411NL(data);
                },
                onQueryDone2: (data) => {
                    this.onQueryDone4198NL(data);
                },
            });

            if (this.accountingPeriod && this.accountingPeriod.end) {
                this.selectedDate =
                    moment(this.accountingPeriod.end).endOf("day").format() ||
                    moment().endOf("day").format();

                const nextAccountingPeriodStart = moment(this.accountingPeriod.end)
                    .clone()
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                if (this.accountingPeriods && this.accountingPeriods.length) {
                    this.nextAccountingPeriod = this.accountingPeriods.find((ap) =>
                        ap.start.startsWith(nextAccountingPeriodStart),
                    );

                    if (this.nextAccountingPeriod && this.nextAccountingPeriod.id) {
                        this.periods.push({
                            period: "N+1",
                            id: this.nextAccountingPeriod.id,
                            onQueryDone: (data) => {
                                this.onQueryDone411NLNextPeriod(data);
                            },
                            onQueryDone2: (data) => {
                                this.onQueryDone4198NLNextPeriod(data);
                            },
                        });
                    }
                }
            }
        }
    }

    // ***********************************************************
    // ********** APOLLO - errMessages - customers - resume ***
    @Apollo({
        // ** AUDIT_ITEMS
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId || !this.accountingPeriod;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;
                if (!data.auditItems?.items?.length) {
                    this.auditItems = undefined;
                } else if (data?.auditItems?.items?.[0]) {
                    this.auditItems = cloneDeep(data.auditItems.items[0]);

                    if (
                        this.auditItems.output?.customers &&
                        !isEmpty(this.auditItems.output.customers)
                    ) {
                        this.customers = this.auditItems.output.customers;

                        if (this.customers?.length) {
                            if (this.auditItems.output?.resume) {
                                this.resume = this.auditItems.output.resume;
                            } else {
                                this.resume = {};
                            }

                            this.results = [];
                            for (let c = 0; c < this.customers.length; c++) {
                                if (this.customers[c].globals?.acrResultDocs?.length) {
                                    this.results.push(...this.customers[c].globals.acrResultDocs);
                                }
                                if (this.customers[c].globals?.simpleOdDocs?.length) {
                                    this.results.push(...this.customers[c].globals.simpleOdDocs);
                                }

                                let customerPeriodAcr: any = {};

                                if (
                                    this.accountingPeriod?.id &&
                                    this.customers[c].globals?.ACRs?.length
                                ) {
                                    const acr = this.customers[c].globals.ACRs.find((acr) => {
                                        acr.accountingPeriodId === this.accountingPeriod.id;
                                        if (!isEmpty(acr)) {
                                            customerPeriodAcr = acr;
                                        }
                                    });
                                }

                                // ** btn period provision disabled
                                if (customerPeriodAcr?.acrData?.[0]) {
                                    this.customers[c].validated =
                                        customerPeriodAcr.acrData[0].validated || false;
                                    this.customers[c].ignored =
                                        customerPeriodAcr.acrData[0].ignored || false;
                                    this.customers[c].comment =
                                        customerPeriodAcr.acrData[0].comment || undefined;
                                    // if (this.customers[c].comment) {
                                    //     this.expandComment(this.customers[c])
                                    // }
                                } else {
                                    this.customers[c].validated = false;
                                    this.customers[c].ignored = false;
                                }

                                // ** sales.documentIds
                                this.customers[c].sales.documentIds = [];

                                for (let d = 0; d < this.customers[c].sales.documents.length; d++) {
                                    this.customers[c].sales.documentIds.push(
                                        this.customers[c].sales.documents[d].id,
                                    );
                                }
                            }
                        }

                        this.createComments();
                    } else {
                        this.customers = [];
                    }

                    if (!isEmpty(this.auditItems.output?.commentsACR)) {
                        this.auditCheckResult = this.auditItems.output.commentsACR; // ** used in AuditCheckDocumentsManager, AuditConnectedAcrDocuments, AuditConnectedAcrResults
                        this.commentsACRId = this.auditCheckResult?.id || "";

                        if (this.auditCheckResult?.documents?.length) {
                            this.connectedDocuments = this.auditCheckResult.documents;
                        }

                        if (this.auditCheckResult.reviewed) {
                            this.reviewed = this.auditCheckResult.reviewed;
                        }

                        // ** results are in this.customers
                        // if (this.auditCheckResult.results) {
                        //     this.results = this.auditCheckResult.results
                        // }

                        if (this.auditCheckResult?.data?.[0]) {
                            const commentsAcrData0 = this.auditCheckResult?.data?.[0];
                            if (commentsAcrData0) {
                                this.longComment = commentsAcrData0.longComment || "";
                                this.shortComment = commentsAcrData0.shortComment || "";
                                this.validated = commentsAcrData0.validated || false;
                            }
                        }
                    } else {
                        this.longComment = "";
                        this.shortComment = "";
                        this.validated = false;
                    }
                } else {
                    this.auditItems = {};
                }
                this.dataLoading = false;
            }
        },
    })
    auditItems: any = {};

    commentsACRId: string = "";

    customers: Array<any> = [];
    resume: any = {};

    reviewed: number = 0;

    // **************** TABLE : PERIOD'S DOCUMENTS *****************
    creditNotesCustomer: any = {};

    async openPeriodDocuments(data, title, customer) {
        if (this.selectedPeriod === title && this.periodsCustomer === customer) {
            this.expand = !this.expand;
        } else {
            this.selectedPeriod = title;
            this.periodsCustomer = customer;

            if (this.customers.length > 0) {
                if (data) {
                    this.periodDocuments = data.documents;
                }
            }
            this.expand = true;
        }
    }

    // **************** TABLE : provisionsList *****************
    async openProvisionsList(data, customer) {
        if (this.provisionCustomer === customer) {
            this.expand2 = !this.expand2;
        } else {
            this.provisionCustomer = customer;
            if (this.customers.length > 0) {
                if (data) {
                    this.provisionsList = data;
                }
            }
            this.expand2 = true;
        }
    }

    // **************** TABLE : unrecoverableLossList *****************
    async openUnrecoverableLossList(data, customer) {
        if (this.unrecoverableLossCustomer === customer) {
            this.expand3 = !this.expand3;
        } else {
            this.unrecoverableLossCustomer = customer;
            this.unrecoverableLossList = [];
            if (this.customers.length > 0) {
                if (data) {
                    for (const d of data) {
                        if (d.data) {
                            this.unrecoverableLossList.push({
                                id: d.id,
                                company: d.company,
                                date: d.date,
                                name: d.name || d.accountingLines[0].wording,
                                unrecoverableLossNetAmount: d.data.unrecoverableLossNetAmount || 0,
                                unrecoverableLossVatAmount: d.data.unrecoverableLossVatAmount || 0,
                                unrecoverableLossGrossAmount:
                                    d.data.unrecoverableLossGrossAmount || 0,
                            });
                        } else if (
                            d.accountingLines &&
                            d.accountingLines[0] &&
                            d.accountingLines[0].wording
                        ) {
                            const unrecoverableLossNetAmount = mathFix(
                                d.accountingLines
                                    .filter((al) => al.accountableAccount.name.startsWith("654"))
                                    .reduce((a, b) => a + b.amountSigned, 0),
                                2,
                            );

                            const unrecoverableLossVatAmount = mathFix(
                                d.accountingLines
                                    .filter((al) => al.accountableAccount.name.startsWith("445"))
                                    .reduce((a, b) => a + b.amountSigned, 0),
                                2,
                            );

                            const unrecoverableLossGrossAmount = mathFix(
                                d.accountingLines
                                    .filter((al) => al.accountableAccount.name.startsWith("411"))
                                    .reduce((a, b) => a + b.amountSigned, 0),
                                2,
                            );

                            this.unrecoverableLossList.push({
                                id: d.id,
                                company: d.company,
                                date: d.date,
                                name: d.name || d.accountingLines[0].wording,
                                unrecoverableLossNetAmount: unrecoverableLossNetAmount || 0,
                                unrecoverableLossVatAmount: unrecoverableLossVatAmount || 0,
                                unrecoverableLossGrossAmount: unrecoverableLossGrossAmount || 0,
                            });
                        }
                    }
                }
            }
            this.expand3 = true;
        }
    }

    // **************** ICON : DOCUMENT VIEW *****************
    openDocument(data) {
        if (data) {
            this.$router.push({
                name: "document",
                params: {
                    companyId: data.company.id,
                    id: data.id,
                },
            });
        }
    }

    // ************ V-WINDOW **************
    step: number = 1;
    stepUL: number = 1;

    get currentTitle() {
        switch (this.step) {
            case 1:
                return `Date d'écriture`;
            case 2:
                return `Choisir un pourcentage`;
            case 3:
                return `Vérifier et valider`;
            default:
                return `Merci`;
        }
    }

    get dataDate() {
        return (
            moment(this.createDocumentDate).startOf("day").format("YYYY-MM-DD") ||
            moment(this.accountingPeriod.end).startOf("day").format("YYYY-MM-DD")
        );
    }

    async openProvisionDialog(customerData) {
        await this.initialiseCompany();
        this.documents = [];
        this.selectedCustomer = customerData.customer;
        if (
            this.accountingPeriod &&
            this.accountingPeriod.id &&
            customerData.globals.ACRs &&
            customerData.globals.ACRs.length
        ) {
            const acr = customerData.globals.ACRs.find((acr) =>
                acr.acrKey.includes(this.accountingPeriod.id),
            );

            this.acr = acr || undefined;
        } else {
            this.acr = undefined;
        }

        this.provisionsDialog = true;
        if (this.customers.length > 0) {
            if (customerData) {
                this.minDate =
                    this.accountingPeriod && this.accountingPeriod.start
                        ? this.formatDatePicker(this.accountingPeriod.start)
                        : this.formatDatePicker(moment().format());
                this.maxDate =
                    this.accountingPeriod && this.accountingPeriod.end
                        ? this.formatDatePicker(this.accountingPeriod.end)
                        : this.formatDatePicker(moment().format());
                this.provision6Base = customerData.basisNetAmountSigned || 0;
                this.provisionBaseGrossAmountSigned = customerData.basisGrossAmountSigned || 0;
                this.cumulated4Provisions =
                    mathFix(customerData.doubtfulls.cumulated4SignedAmount, 2) || 0;
                this.cumulatedPercent = this.cumulated4Provisions
                    ? mathFix((100 * this.cumulated4Provisions) / this.provision6Base, 2)
                    : 0;
                this.periodYear = moment(customerData.periodEnd).format("YYYY");
                this.invoicesToProvision = customerData.sales.documents;
            }
        }
    }

    async openUnrecoverableLossDialog(customerData2) {
        await this.initialiseCompany();

        this.selectedCustomer = customerData2.customer;

        let acr: any = undefined;

        if (this.accountingPeriod?.id && customerData2.globals?.ACRs?.length) {
            const acrs = JSON.parse(JSON.stringify(customerData2.globals.ACRs));
            acr = acrs.find((acr) => acr.acrKey.includes(this.accountingPeriod.id));
        }

        this.unrecoverableLossDialog = true;
        this.switchManual = false;
        const vat7accountableAccounts = [];
        // const vatBasis = JSON.parse(JSON.stringify(this.defaultVatBasis))
        const vatBasis = JSON.parse(JSON.stringify(this.vatBasis));

        if (customerData2) {
            this.minDate =
                this.accountingPeriod && this.accountingPeriod.start
                    ? this.formatDatePicker(this.accountingPeriod.start)
                    : this.formatDatePicker(moment().format());
            this.maxDate =
                this.accountingPeriod && this.accountingPeriod.end
                    ? this.formatDatePicker(this.accountingPeriod.end)
                    : this.formatDatePicker(moment().format());

            this.provisionReversal =
                mathFix(customerData2.doubtfulls.cumulated4SignedAmount, 2) || 0;

            // ** sales
            if (customerData2.sales?.documents?.length) {
                const salesPlusAAEsDocuments = JSON.parse(
                    JSON.stringify(customerData2.sales.documents),
                );
                if (customerData2.creditNotes?.documents?.length) {
                    salesPlusAAEsDocuments.push(...customerData2.creditNotes.documents);
                }
                for (const doc of salesPlusAAEsDocuments) {
                    for (const al of doc.accountingLines) {
                        if (al.accountableAccount.name.startsWith("7")) {
                            if (!vat7accountableAccounts.length) {
                                vat7accountableAccounts.push({
                                    accountableAccountName: al.accountableAccount.name,
                                    amountsSigned: [al.amountSigned],
                                });
                            } else if (vat7accountableAccounts.length) {
                                const existingAA = vat7accountableAccounts.find(
                                    (x) => x.accountableAccountName === al.accountableAccount.name,
                                );
                                if (existingAA) {
                                    const indexOfAA = vat7accountableAccounts.indexOf(existingAA);
                                    vat7accountableAccounts[indexOfAA].amountsSigned.push(
                                        al.amountSigned,
                                    );
                                } else {
                                    vat7accountableAccounts.push({
                                        accountableAccountName: al.accountableAccount.name,
                                        amountsSigned: [al.amountSigned],
                                    });
                                }
                            }
                        }
                    }
                }

                // ** sales
                for (const aa of vat7accountableAccounts) {
                    aa.amountSigned = aa.amountsSigned.reduce((a, b) => a + b, 0);
                    // if (aa.accountableAccountName.endsWith("02")) {
                    //     vatBasis["02"].amountSigned += aa.amountSigned;
                    // } else if (aa.accountableAccountName.endsWith("05")) {
                    //     vatBasis["05"].amountSigned += aa.amountSigned;
                    // } else if (aa.accountableAccountName.endsWith("08")) {
                    //     vatBasis["08"].amountSigned += aa.amountSigned;
                    // } else if (aa.accountableAccountName.endsWith("10")) {
                    //     vatBasis["10"].amountSigned += aa.amountSigned;
                    // } else if (aa.accountableAccountName.endsWith("20")) {
                    //     vatBasis["20"].amountSigned += aa.amountSigned;
                    // } else if (aa.accountableAccountName.endsWith("00")) {
                    //     this.vatBasis00AmountSigned += aa.amountSigned;
                    // } else if (aa.accountableAccountName.endsWith("30")) {
                    //     vatBasis["30"].amountSigned += aa.amountSigned;
                    // } else if (aa.accountableAccountName.endsWith("80")) {
                    //     vatBasis["80"].amountSigned += aa.amountSigned;
                    // } else if (aa.accountableAccountName.endsWith("90")) {
                    //     vatBasis["90"].amountSigned += aa.amountSigned;
                    // }
                    if (aa.vatRate && aa.vatRate > 0) {
                        for (const key in vatBasis) {
                            if (aa.vatRate === vatBasis[key].vatRate) {
                                vatBasis[key].amountSigned += aa.amountSigned;
                                return;
                            }
                        }
                    } else if (aa.vatType) {
                        if (aa.vaType === "INTRACOM") {
                            // not vat accountable account (sales account)
                            vatBasis["30"].amountSigned += aa.amountSigned;
                        } else if (aa.vatType === "EXPORT") {
                            vatBasis["80"].amountSigned += aa.amountSigned;
                        } else if (aa.vatType === "REVERSE_CHARGE") {
                            vatBasis["90"].amountSigned += aa.amountSigned;
                        }
                    } else if (aa.accountableAccountName.endsWith("00")) {
                        this.vatBasis00AmountSigned += aa.amountSigned;
                    }
                }
            }

            if (this.vatBasis00AmountSigned) {
                this.switchManual = true;
            }

            // ** previous unrecoverableLosses to vatBasis
            // ** difference de nommage : data + aa.accountableAccountName vs aa.accountableAccount.name
            if (customerData2.unrecoverableLoss) {
                if (
                    customerData2.unrecoverableLoss.documents &&
                    customerData2.unrecoverableLoss.documents.length
                ) {
                    for (const doc of customerData2.unrecoverableLoss.documents) {
                        if (doc.data && doc.data.dataPreviousAmountsSigned) {
                            if (Object.keys(doc.data.dataPreviousAmountsSigned).length) {
                                for (const k of Object.keys(doc.data.dataPreviousAmountsSigned)) {
                                    vatBasis[k].previousNetAmountSigned +=
                                        doc.data.dataPreviousAmountsSigned[k];
                                }
                            }
                        }
                    }
                }

                if (customerData2.unrecoverableLoss.ODs) {
                    // ** déduire du montant total
                    // ** afficher "autres bases - % de TVA pas définie"
                    // ** lors des saisies des bases manuelles
                    // ** réduire d'autant

                    // ** si OD simple ...
                    for (const doc of customerData2.unrecoverableLoss.ODs) {
                        // ** faire le total des HT
                        const als6 = doc.accountingLines.filter((al) =>
                            al.accountableAccount.name.startsWith("654"),
                        );
                        const sum6 = mathFix(
                            als6.reduce((a, b) => a + b.amountSigned, 0),
                            2,
                        );

                        // vatBasis["00"].previousNetAmountSigned += mathFix(sum6, 2);

                        // ** récupérer les VatAmounts
                        const al445 = doc.accountingLines.filter((al) =>
                            al.accountableAccount.name.startsWith("445"),
                        );
                        for (const vat of al445) {
                            // ** isoler le vatRate
                            const rate = vat.accountableAccount.name.slice(-2);
                            // ** calculer la base par %
                            vatBasis[rate].previousNetAmountSigned = mathFix(
                                (vat.amountSigned * 100) / vatBasis[rate].vatRate,
                                2,
                            );
                        }
                    }
                }
            }

            for (const vatBase in vatBasis) {
                vatBasis[vatBase].gapAmountSigned = vatBasis[vatBase].amountSigned;

                if (vatBasis[vatBase].previousNetAmountSigned != 0) {
                    vatBasis[vatBase].previousNetAmountSigned = mathFix(
                        vatBasis[vatBase].previousNetAmountSigned,
                        2,
                    );

                    vatBasis[vatBase].gapAmountSigned =
                        vatBasis[vatBase].amountSigned + vatBasis[vatBase].previousNetAmountSigned;
                }

                if (vatBasis[vatBase].vatRate != 0) {
                    vatBasis[vatBase].vatAmountSigned = mathFix(
                        (vatBasis[vatBase].gapAmountSigned * vatBasis[vatBase].vatRate) / 100,
                        2,
                    );
                    vatBasis[vatBase].grossAmountSigned = mathFix(
                        -(vatBasis[vatBase].gapAmountSigned + vatBasis[vatBase].vatAmountSigned),
                        2,
                    );
                } else {
                    vatBasis[vatBase].grossAmountSigned = vatBasis[vatBase].gapAmountSigned;
                }
            }

            if (
                this.accountingPeriod &&
                this.accountingPeriod.id &&
                customerData2.globals.ACRs &&
                customerData2.globals.ACRs.length
            ) {
                if (acr) {
                    // ** sets vatBasis with previousNetAmountSigned
                    if (acr.acrData.length && vatBasis) {
                        for (const ad of acr.acrData) {
                            if (
                                ad.unrecoverableLoss &&
                                ad.unrecoverableLoss.datapreviousAmountsSigned &&
                                Object.keys(ad.unrecoverableLoss.datapreviousAmountsSigned).length
                            ) {
                                this.switchManual = true;

                                for (const dmas of Object.keys(
                                    ad.unrecoverableLoss.datapreviousAmountsSigned,
                                )) {
                                    vatBasis[dmas].previousNetAmountSigned =
                                        ad.unrecoverableLoss.datapreviousAmountsSigned[dmas];
                                }
                            }
                        }
                    }
                }
            }
            this.periodYear = moment(customerData2.periodEnd).format("YYYY");
        }
        this.acr = acr || undefined;
        this.vatBasis = vatBasis;
    }

    async calculateProvision() {
        this.step++;
    }

    changeManualUnrecoverableLoss(vatBasisItem) {
        if (vatBasisItem.manualAmount) {
            // ** all keys
            vatBasisItem.manualAmountSigned = -vatBasisItem.manualAmount;
            vatBasisItem.manualGrossAmountSigned = -vatBasisItem.manualAmountSigned;

            // ** VAT keys
            if (vatBasisItem.vatRate) {
                vatBasisItem.manualVatAmountSigned = mathFix(
                    (vatBasisItem.manualAmountSigned * vatBasisItem.vatRate) / 100,
                    2,
                );
                vatBasisItem.manualGrossAmountSigned = mathFix(
                    -vatBasisItem.manualAmountSigned - vatBasisItem.manualVatAmountSigned,
                    2,
                );
            } else if (this.vatBasis00AmountSigned) {
                // ** 0 VAT keys (export)
                // ** sets this.vatBasis['current'] values
                this.vatBasis00AmountSigned -= vatBasisItem.manualAmountSigned;
            } else {
                console.error(
                    "🚀 - file: CheckDoubtfullAccounts.vue - changeManualUnrecoverableLoss - vatBasisItem.manualAmount - ERROR : ",
                    vatBasisItem.manualAmount,
                );
            }
        }
    }

    async quitProvisionDialog() {
        await this.initialiseCompany();
    }

    async quitUnrecoverableLossDialog() {
        await this.initialiseCompany();
    }

    async previous(stepNumber) {
        this.step -= stepNumber;
    }

    async next(stepNumber) {
        this.step += stepNumber;
    }

    async previousUL(stepNumber) {
        this.step -= stepNumber;
    }

    async nextUL(stepNumber) {
        this.stepUL += stepNumber;
    }

    get createDocumentDate() {
        return (
            moment(this.selectedDate).format("YYYY-MM-DD") ||
            moment(this.accountingPeriod.end).format("YYYY-MM-DD")
        );
    }

    async onDatePickerChange2(date) {
        this.selectedDate = getDBFormattedDate(date);
        this.createDocumentDate;
    }

    async onDatePickerChange3(date) {
        this.selectedDate = getDBFormattedDate(date);
        this.createDocumentDate;
    }

    get errorMessage() {
        if (this.newPercent && this.cumulatedPercent) {
            const remainingPercent = 100 - this.cumulatedPercent;
            if (this.newPercent < 1 || this.newPercent > remainingPercent) {
                return "Le pourcentage GLOBAL doit être compris entre 1 et 100";
            }
        } else if (this.newPercent < 1 || this.newPercent > 100) {
            return "Le pourcentage GLOBAL doit être compris entre 1 et 100";
        }
        return "";
    }

    async generateProvisionsDocuments() {
        const data = [];

        // ** il ne faut pas écraser data et results
        // ** mais récupérer et push
        if (this.acr?.acrData?.length) {
            data.push(...this.acr.acrData);
        }

        if (this.provision6Base && this.newPercent) {
            this.deltaPercent =
                this.newPercent && this.cumulatedPercent
                    ? mathFix(this.newPercent - this.cumulatedPercent)
                    : this.newPercent
                      ? this.newPercent
                      : this.cumulatedPercent
                        ? this.cumulatedPercent
                        : 0;

            this.new4ProvisionAmount = mathFix((this.provision6Base * this.newPercent) / 100);

            this.delta4ProvisionAmount =
                this.cumulated4Provisions && this.new4ProvisionAmount
                    ? mathFix(this.new4ProvisionAmount - this.cumulated4Provisions)
                    : this.new4ProvisionAmount
                      ? this.new4ProvisionAmount
                      : this.cumulated4Provisions
                        ? this.cumulated4Provisions
                        : 0;
        }

        const accountingLines = [];
        this.documents = [];
        this.provisionDocumentsAls = [];

        const alGeneric = {
            date: this.createDocumentDate,
            wording:
                this.cumulated4Provisions && this.delta4ProvisionAmount
                    ? this.selectedCustomer.name +
                      " - Regul prov " +
                      this.deltaPercent +
                      "% " +
                      newCommonFormatCurrency(-this.delta4ProvisionAmount) +
                      " HT = " +
                      this.newPercent +
                      "% de " +
                      newCommonFormatCurrency(-this.provision6Base) +
                      " (solde HT " +
                      this.periodYear +
                      ") - " +
                      moment(this.createDocumentDate).format("DD/MM/YYYY")
                    : this.selectedCustomer.name +
                      " - Prov " +
                      this.deltaPercent +
                      "% " +
                      " HT = " +
                      "% de " +
                      " (solde HT " +
                      this.periodYear +
                      ") - " +
                      moment(this.createDocumentDate).format("DD/MM/YYYY"),
        };

        const aLObject6or7 = {
            amountSigned: -this.delta4ProvisionAmount,
            amount:
                this.delta4ProvisionAmount > 0
                    ? this.delta4ProvisionAmount
                    : -this.delta4ProvisionAmount,
            accountableAccount:
                this.delta4ProvisionAmount < 0
                    ? await getConnectAccountableAccount(this.$store, this.$apollo, "681740")
                    : await getConnectAccountableAccount(this.$store, this.$apollo, "781740"),
            company: { connect: { id: this.companyId } },
            type: "ACCOUNTING",
        };
        accountingLines.push({ ...alGeneric, ...aLObject6or7 });

        const aLObject491 = {
            amountSigned: this.delta4ProvisionAmount,
            amount: Math.abs(this.delta4ProvisionAmount),
            accountableAccount: await getConnectAccountableAccount(
                this.$store,
                this.$apollo,
                "491000",
            ),
            thirdPartyCompany: { connect: { id: this.selectedCustomer.id } },
            useForReconciliation: true,
            company: { connect: { id: this.companyId } },
            type: "ACCOUNTING",
        };
        accountingLines.push({ ...alGeneric, ...aLObject491 });

        // ** il ne faut pas écraser data et results
        // ** mais récupérer et push
        if (this.acr?.acrData?.[0]) {
            data.push(this.acr.acrData[0]);
            if (data[0].doubtfulls) {
                (data[0].doubtfulls.date = this.createDocumentDate),
                    (data[0].doubtfulls.provision6Base = this.provision6Base),
                    (data[0].doubtfulls.delta4ProvisionAmount += this.delta4ProvisionAmount);
                data[0].doubtfulls.cumulated4Provisions =
                    this.cumulated4Provisions + this.delta4ProvisionAmount;
                (data[0].accountingPeriodId = this.accountingPeriodId),
                    (data[0].validated = this.selectedCustomer.validated);
                data[0].date = this.createDocumentDate || this.accountingPeriod.end;
                data[0].comment = this.selectedCustomer.comment;
            } else if (data[0]) {
                data[0].doubtfulls = {
                    accountingPeriodId: this.accountingPeriodId,
                    thirdPartyCompany: this.selectedCustomer,
                    date: this.createDocumentDate,
                    provision6Base: this.provision6Base,
                    delta4ProvisionAmount: this.delta4ProvisionAmount,
                    cumulated4Provisions: this.cumulated4Provisions + this.delta4ProvisionAmount,
                    validated: this.selectedCustomer.validated,
                    comment: this.selectedCustomer.comment,
                };
            }
        } else {
            data.push({
                doubtfulls: {
                    accountingPeriodId: this.accountingPeriodId,
                    thirdPartyCompany: this.selectedCustomer,
                    date: this.createDocumentDate,
                    provision6Base: this.provision6Base,
                    delta4ProvisionAmount: this.delta4ProvisionAmount,
                    cumulated4Provisions: this.cumulated4Provisions + this.delta4ProvisionAmount,
                },
            });
        }

        // ++ validateProvision
        if (accountingLines?.length) {
            const document: any = getEmptyDocument(
                this.companyId,
                alGeneric.wording,
                "MISCELLANEOUS_OPERATION",
                this.createDocumentDate,
                this.currentUser.id,
                this.selectedCustomer.id,
                accountingLines,
                true,
            );

            this.data = data;
            this.documents.push(document);
            this.provisionDocumentsAls.push(...document.accountingLines.create);
        }
    }

    async validateProvision() {
        const customerPeriodAcrKey =
            this.acKey +
            "_" +
            this.companyId +
            "_" +
            this.accountingPeriodId +
            "_" +
            this.selectedCustomer.id;

        const upsertVariables: any = {
            id: this.acr?.acrId || "",
            key: customerPeriodAcrKey,
            companyId: this.companyId,
            status: "UNKNOWN",
            thirdPartyCompanyCreate:
                this.selectedCustomer && this.selectedCustomer.id
                    ? { connect: { id: this.selectedCustomer.id } }
                    : undefined,
            thirdPartyCompanyUpdate:
                this.selectedCustomer && this.selectedCustomer.id
                    ? { connect: { id: this.selectedCustomer.id } }
                    : undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            deleteDocuments: [],
            documents: this.documents,
            auditCheckKey: this.acKey,
            data: JSON.parse(JSON.stringify(this.data)),
        };

        // eslint-disable-next-line no-await-in-loop
        const resultProvision: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });
        await this.initialiseCompany();
        this.refresh();

        this.step = 1;
    }

    refresh() {
        if (this.$apollo.queries?.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            debugger; // git-ignore
        }
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    async generateUnrecoverableLossDocuments() {
        await this.initialiseCompany();
        this.documents = [];
        this.provisionDocumentsAls = [];
        this.unrecoverableLossDocumentsAls = [];
        const data = [];

        // ** il ne faut pas écraser data et results
        // ** mais récupérer et push
        if (this.acr?.acrData?.length) {
            data.push(...this.acr.acrData);
        }

        // +++++++++++++++++++++
        // ++ reprise provisions
        // +++++++++++++++++++++
        if (this.provisionReversal) {
            const accountingLines = [];

            // ** il ne faut pas écraser data et results
            // ** mais récupérer et push

            const alGenericProv = {
                date: this.createDocumentDate,
                wording:
                    this.selectedCustomer.name +
                    " - Reprise prov précédentes - " +
                    newCommonFormatCurrency(-this.provisionReversal) +
                    " HT - " +
                    moment(this.createDocumentDate).format("DD/MM/YYYY"),
            };

            const aLObject6or7 = {
                amountSigned: this.provisionReversal,
                amount:
                    this.provisionReversal > 0 ? this.provisionReversal : -this.provisionReversal,
                accountableAccount: await getConnectAccountableAccount(
                    this.$store,
                    this.$apollo,
                    "781740",
                ),
                company: { connect: { id: this.companyId } },
                type: "ACCOUNTING",
            };
            accountingLines.push({ ...alGenericProv, ...aLObject6or7 });

            const aLObject491 = {
                amountSigned: -this.provisionReversal,
                amount:
                    this.provisionReversal > 0 ? this.provisionReversal : -this.provisionReversal,
                accountableAccount: await getConnectAccountableAccount(
                    this.$store,
                    this.$apollo,
                    "491000",
                ),
                thirdPartyCompany: { connect: { id: this.selectedCustomer.id } },
                useForReconciliation: true,
                company: { connect: { id: this.companyId } },
                type: "ACCOUNTING",
            };
            accountingLines.push({ ...alGenericProv, ...aLObject491 });

            if (data?.[0]?.doubtfulls) {
                data[0].doubtfulls.accountingPeriodId = this.accountingPeriodId;
                data[0].doubtfulls.thirdPartyCompany = this.selectedCustomer;
                data[0].doubtfulls.date = this.createDocumentDate;
                data[0].doubtfulls.provisionReversal = this.provisionReversal;
                data[0].doubtfulls.cumulated4Provisions -= this.provisionReversal;
                data[0].doubtfulls.delta4ProvisionAmount -= this.provisionReversal;
                data[0].ignored = false;
                data[0].validated = true;
                data[0].date = this.dataDate;
                data[0].comment = this.data?.[0]?.comment || "";
            } else if (data?.[0]) {
                data[0] = {
                    doubtfulls: {
                        accountingPeriodId: this.accountingPeriodId,
                        thirdPartyCompany: this.selectedCustomer,
                        date: this.createDocumentDate,
                        provisionReversal: this.provisionReversal,
                        cumulated4Provisions: 0,
                        delta4ProvisionAmount: 0,
                    },
                    ignored: false,
                    validated: true,
                    date: this.dataDate,
                    comment: this.data?.[0]?.comment || "",
                };
            } else {
                data.push({
                    doubtfulls: {
                        accountingPeriodId: this.accountingPeriodId,
                        thirdPartyCompany: this.selectedCustomer,
                        date: this.createDocumentDate,
                        provisionReversal: this.provisionReversal,
                        cumulated4Provisions: 0,
                        delta4ProvisionAmount: 0,
                    },
                    ignored: false,
                    validated: true,
                    date: this.dataDate,
                    comment: this.data?.[0]?.comment || "",
                });
            }

            if (accountingLines && accountingLines.length) {
                const document: any = getEmptyDocument(
                    this.companyId,
                    alGenericProv.wording,
                    "MISCELLANEOUS_OPERATION",
                    this.createDocumentDate,
                    this.currentUser.id,
                    this.selectedCustomer.id,
                    accountingLines,
                    true,
                );

                this.documents.push(document);
                this.provisionDocumentsAls.push(...document.accountingLines.create);
            }
            this.provisionReversal = 0;
        }

        // ++ +++++++++++++++++++
        // ++ passage en perte
        // ++ +++++++++++++++++++
        const accountingLines = [];

        const dataPreviousAmountsSigned: any = {};

        // ** sums, only for alGeneric.wording
        this.unrecoverableLossNetAmount = mathFix(
            Object.values(this.vatBasis).reduce(
                (a, b) =>
                    a -
                    parseFloat(
                        this.switchManual && b.manualAmountSigned
                            ? b.manualAmountSigned + b.gapAmountSigned
                            : b.gapAmountSigned,
                    ),
                0,
            ),
            2,
        );

        this.unrecoverableLossVatAmount = mathFix(
            Object.values(this.vatBasis).reduce(
                (a, b) =>
                    a -
                    parseFloat(
                        this.switchManual && b.manualVatAmountSigned
                            ? b.manualVatAmountSigned + b.vatAmountSigned
                            : b.vatAmountSigned,
                    ),
                0,
            ),
            2,
        );

        // ** sums, for alGeneric.wording and aLObject411
        this.unrecoverableLossGrossAmount = mathFix(
            Object.values(this.vatBasis).reduce(
                (a, b) =>
                    a -
                    parseFloat(
                        this.switchManual && b.manualGrossAmountSigned
                            ? b.manualGrossAmountSigned + b.grossAmountSigned
                            : b.grossAmountSigned,
                    ),
                0,
            ),
            2,
        );

        const alGeneric = {
            date: this.createDocumentDate,
            wording:
                this.unrecoverableLossNetAmount && this.unrecoverableLossVatAmount
                    ? this.selectedCustomer.name +
                      " - Créance irrécouvrable " +
                      newCommonFormatCurrency(this.unrecoverableLossNetAmount) +
                      " HT - " +
                      newCommonFormatCurrency(this.unrecoverableLossVatAmount) +
                      " TVA - " +
                      newCommonFormatCurrency(-this.unrecoverableLossGrossAmount) +
                      " TTC - " +
                      moment(this.createDocumentDate).format("DD/MM/YYYY")
                    : this.selectedCustomer.name +
                      " - Créance irrécouvrable " +
                      newCommonFormatCurrency(this.unrecoverableLossNetAmount) +
                      " HT - pas de TVA - " +
                      newCommonFormatCurrency(this.unrecoverableLossGrossAmount) +
                      " TTC - " +
                      moment(this.createDocumentDate).format("DD/MM/YYYY"),
        };

        // ** c/6 + 4457 for every key
        for (const key in this.vatBasis) {
            if (
                this.vatBasis[key].previousNetAmountSigned !== 0 ||
                this.vatBasis[key].gapAmountSigned !== 0 ||
                this.vatBasis[key].manualAmountSigned
            ) {
                if (this.vatBasis[key].manualAmountSigned !== 0) {
                    dataPreviousAmountsSigned[key] =
                        this.vatBasis[key].previousNetAmountSigned -
                        this.vatBasis[key].manualAmountSigned;
                } else {
                    dataPreviousAmountsSigned[key] =
                        this.vatBasis[key].previousNetAmountSigned -
                        this.vatBasis[key].gapAmountSigned;
                }

                const aLObject654 = {
                    amountSigned:
                        this.switchManual && this.vatBasis[key].manualAmountSigned
                            ? -this.vatBasis[key].manualAmountSigned
                            : -this.vatBasis[key].gapAmountSigned,
                    amount:
                        this.switchManual && this.vatBasis[key].manualAmountSigned
                            ? Math.abs(this.vatBasis[key].manualAmountSigned)
                            : Math.abs(this.vatBasis[key].gapAmountSigned),
                    originalAccountableAccount: "654000",
                    accountableAccount: await getConnectAccountableAccount(
                        this.$store,
                        this.$apollo,
                        "654000",
                    ),
                    company: { connect: { id: this.companyId } },
                    type: "ACCOUNTING",
                };

                accountingLines.push({ ...alGeneric, ...aLObject654 });

                if (
                    this.vatBasis[key].vatAmountSigned !== 0 &&
                    this.vatBasis[key].accountableAccountName
                ) {
                    const aLObjectVAT = {
                        amountSigned:
                            this.switchManual && this.vatBasis[key].manualVatAmountSigned
                                ? -this.vatBasis[key].manualVatAmountSigned
                                : -this.vatBasis[key].vatAmountSigned,
                        amount:
                            this.switchManual && this.vatBasis[key].manualVatAmountSigned
                                ? Math.abs(this.vatBasis[key].manualVatAmountSigned)
                                : Math.abs(this.vatBasis[key].vatAmountSigned),
                        originalAccountableAccount: this.vatBasis[key].accountableAccountName,
                        accountableAccount: await getConnectAccountableAccount(
                            this.$store,
                            this.$apollo,
                            this.vatBasis[key].accountableAccountName,
                            undefined,
                            undefined,
                            true,
                        ),
                        company: { connect: { id: this.companyId } },
                        type: "ACCOUNTING",
                    };

                    accountingLines.push({ ...alGeneric, ...aLObjectVAT });
                }
            }
        }

        // ** thirdPartyCompany AL
        const aLObject411 = {
            amountSigned:
                this.unrecoverableLossGrossAmount > 0
                    ? -this.unrecoverableLossGrossAmount
                    : this.unrecoverableLossGrossAmount,
            amount: Math.abs(this.unrecoverableLossGrossAmount),
            originalAccountableAccount: "411000",
            accountableAccount: await getConnectAccountableAccount(
                this.$store,
                this.$apollo,
                "411000",
            ),
            thirdPartyCompany: { connect: { id: this.selectedCustomer.id } },
            useForReconciliation: true,
            company: { connect: { id: this.companyId } },
            type: "ACCOUNTING",
        };
        accountingLines.push({ ...alGeneric, ...aLObject411 });

        if (data.length && data[0] && data[0].unrecoverableLoss) {
            data[0].unrecoverableLoss.unrecoverableLossNetAmount = this.unrecoverableLossNetAmount;
            data[0].unrecoverableLoss.unrecoverableLossVatAmount = this.unrecoverableLossVatAmount;
            data[0].unrecoverableLoss.unrecoverableLossGrossAmount =
                this.unrecoverableLossGrossAmount;
            data[0].unrecoverableLoss.dataPreviousAmountsSigned = dataPreviousAmountsSigned;
            data[0].ignored = false;
            data[0].validated = true;
            data[0].date = this.dataDate;
            data[0].comment = this.data?.[0]?.comment || "";
        } else if (data.length && data[0]) {
            (data[0].unrecoverableLoss = {
                accountingPeriodId: this.accountingPeriodId,
                thirdPartyCompany: this.selectedCustomer,
                date: this.dataDate,
                unrecoverableLossNetAmount: this.unrecoverableLossNetAmount,
                unrecoverableLossVatAmount: this.unrecoverableLossVatAmount,
                unrecoverableLossGrossAmount: this.unrecoverableLossGrossAmount,
                dataPreviousAmountsSigned: dataPreviousAmountsSigned,
            }),
                (data[0].ignored = false);
            data[0].validated = true;
            data[0].date = this.dataDate;
            data[0].comment = this.data?.[0]?.comment || "";
        } else {
            data.push({
                unrecoverableLoss: {
                    accountingPeriodId: this.accountingPeriodId,
                    thirdPartyCompany: this.selectedCustomer,
                    date: this.dataDate,
                    unrecoverableLossNetAmount: this.unrecoverableLossNetAmount,
                    unrecoverableLossVatAmount: this.unrecoverableLossVatAmount,
                    unrecoverableLossGrossAmount: this.unrecoverableLossGrossAmount,
                    dataPreviousAmountsSigned: dataPreviousAmountsSigned,
                },
                ignored: false,
                validated: true,
                date: this.dataDate,
                comment: this.data?.[0]?.comment || "",
            });
        }

        // ++ unrecoverableLoss
        if (accountingLines.length) {
            const document: any = getEmptyDocument(
                this.companyId,
                accountingLines[0].wording,
                "MISCELLANEOUS_OPERATION",
                this.createDocumentDate,
                this.currentUser.id,
                this.selectedCustomer.id,
                accountingLines,
                true,
            );

            document.data = {
                accountingPeriodId: this.accountingPeriodId,
                thirdPartyCompany: this.selectedCustomer,
                date: this.dataDate,
                unrecoverableLossNetAmount: this.unrecoverableLossNetAmount,
                unrecoverableLossVatAmount: this.unrecoverableLossVatAmount,
                unrecoverableLossGrossAmount: this.unrecoverableLossGrossAmount,
                dataPreviousAmountsSigned: dataPreviousAmountsSigned,
            };
            this.data = data;
            this.documents.push(document);
            this.unrecoverableLossDocumentsAls.push(...document.accountingLines.create);
        }
        this.nextUL(1); // ** dialog step
    }

    async validateUnrecoverableLoss() {
        const customerPeriodAcrKey =
            this.acKey +
            "_" +
            this.companyId +
            "_" +
            this.accountingPeriodId +
            "_" +
            this.selectedCustomer.id;

        const upsertVariables: any = {
            id: this.acr?.acrId || "",
            key: customerPeriodAcrKey,
            companyId: this.companyId,
            status: "UNKNOWN",
            thirdPartyCompanyCreate:
                this.selectedCustomer && this.selectedCustomer.id
                    ? { connect: { id: this.selectedCustomer.id } }
                    : undefined,
            thirdPartyCompanyUpdate:
                this.selectedCustomer && this.selectedCustomer.id
                    ? { connect: { id: this.selectedCustomer.id } }
                    : undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            deleteDocuments: [],
            documents: this.documents,
            auditCheckKey: this.acKey,
            data: this.data,
        };

        // eslint-disable-next-line no-await-in-loop
        const resultUnrecoverableLoss: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        if (resultUnrecoverableLoss) {
            this.refresh();
        }

        this.unrecoverableLossNetAmount = 0.0;
        this.unrecoverableLossVatAmount = 0.0;
        this.unrecoverableLossGrossAmount = 0.0;
        this.provisionReversal = 0.0;

        this.unrecoverableLossDialog = false;

        this.minDate =
            this.accountingPeriod && this.accountingPeriod.start
                ? this.formatDatePicker(this.accountingPeriod.start)
                : this.formatDatePicker(moment().format());
        this.maxDate =
            this.accountingPeriod && this.accountingPeriod.end
                ? this.formatDatePicker(this.accountingPeriod.end)
                : this.formatDatePicker(moment().format());
        this.stepUL = 1;
    }

    async validateCustomer(customerData3) {
        customerData3.validated = !customerData3.validated;

        this.selectedCustomer = customerData3.customer;

        if (
            this.accountingPeriod?.id &&
            customerData3.globals?.ACRs?.length &&
            this.selectedCustomer?.id
        ) {
            const acr = customerData3.globals.ACRs.find((acr) =>
                acr.acrKey.includes(this.accountingPeriod.id && this.selectedCustomer?.id),
            );
            if (acr) {
                this.acr = acr || undefined;
            }
        } else {
            this.acr = undefined;
        }
        // this.customerFoundedACR(customerData3);
        const data = [];

        // ** il ne faut pas écraser data et results
        // ** mais récupérer et push
        if (this.acr?.acrData?.length) {
            data.push(...this.acr.acrData);
        }

        if (data.length) {
            (data[0].accountingPeriodId = this.accountingPeriodId),
                (data[0].ignored = customerData3.ignored);
            data[0].validated = customerData3.validated;
            data[0].date = this.dataDate;
            data[0].comment = customerData3.comment;
        } else {
            data.push({
                accountingPeriodId: this.accountingPeriodId,
                ignored: customerData3.ignored,
                validated: customerData3.validated,
                date: this.dataDate,
                comment: customerData3.comment,
            });
        }

        // if (customerData3.ignored || customerData3.validated) {
        //     if (customerData3.sales && customerData3.sales.netAmountSigned) {
        data[0].sales =
            customerData3.sales && customerData3.sales.netAmountSigned
                ? { netAmountSigned: customerData3.sales.netAmountSigned }
                : { netAmountSigned: 0 };
        //     }
        // } else {
        //     data[0].sales = {netAmountSigned: 0}
        // }

        // ++ validateCustomer
        const customerPeriodAcrKey =
            this.acKey +
            "_" +
            this.companyId +
            "_" +
            this.accountingPeriodId +
            "_" +
            this.selectedCustomer.id;

        const upsertVariables: any = {
            id: this.acr?.acrId || "",
            key: customerPeriodAcrKey,
            companyId: this.companyId,
            status: "UNKNOWN",
            thirdPartyCompanyCreate:
                this.selectedCustomer && this.selectedCustomer.id
                    ? { connect: { id: this.selectedCustomer.id } }
                    : undefined,
            thirdPartyCompanyUpdate:
                this.selectedCustomer && this.selectedCustomer.id
                    ? { connect: { id: this.selectedCustomer.id } }
                    : undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            deleteDocuments: [],
            // documents: undefined,
            auditCheckKey: this.acKey,
            data: data,
        };

        // eslint-disable-next-line no-await-in-loop
        const resultUnrecoverableLoss: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        this.refresh();
    }

    async ignoreCustomer(customerData5) {
        customerData5.ignored = !customerData5.ignored;

        let acr: any = undefined;

        if (
            this.accountingPeriod?.id &&
            customerData5.globals?.ACRs?.length &&
            customerData5.customer?.id
        ) {
            acr = customerData5.globals.ACRs.find((acr) =>
                acr.acrKey.includes(this.accountingPeriod.id && customerData5.customer.id),
            );
        }

        let data = [];

        // ** il ne faut pas écraser data et results
        // ** mais récupérer et push
        if (acr?.acrData?.length) {
            data = acr.acrData;
        }

        if (data.length) {
            // data[0].accountingPeriodId = this.accountingPeriodId,
            data[0].ignored = customerData5.ignored;
        } else {
            data.push({
                accountingPeriodId: this.accountingPeriodId,
                ignored: customerData5.ignored,
                validated: customerData5.validated,
                date: this.dataDate,
                comment: customerData5.comment || "",
            });
        }
        // if (customerData5.ignored || customerData5.validated) {
        // data[0].sales = customerData5.sales?.netAmountSigned ? {netAmountSigned: customerData5.sales.netAmountSigned} :
        //     {netAmountSigned: 0}
        // }

        // data[0].doubtfulls = customerData5.doubtfulls?.cumulated4SignedAmount ? {cumulated4SignedAmount: customerData5.doubtfulls?.cumulated4SignedAmount} : {cumulated4SignedAmount: 0}

        // data[0].unrecoverableLoss = customerData5.unrecoverableLoss?.cumulated4SignedAmount ? {cumulated4SignedAmount: customerData5.unrecoverableLoss?.cumulated4SignedAmount} : {cumulated4SignedAmount: 0}

        // ++ ignoreCustomer
        const customerPeriodAcrKey =
            this.acKey +
            "_" +
            this.companyId +
            "_" +
            this.accountingPeriodId +
            "_" +
            customerData5.customer.id;

        const upsertVariables: any = {
            id: acr?.acrId || "",
            key: customerPeriodAcrKey,
            companyId: this.companyId,
            status: "UNKNOWN",
            thirdPartyCompanyCreate: customerData5.customer?.id
                ? { connect: { id: customerData5.customer.id } }
                : undefined,
            thirdPartyCompanyUpdate: customerData5.customer?.id
                ? { connect: { id: customerData5.customer.id } }
                : undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            deleteDocuments: [],
            // documents: undefined,
            auditCheckKey: this.acKey,
            data: data,
        };

        // eslint-disable-next-line no-await-in-loop
        const resultUnrecoverableLoss: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        if (resultUnrecoverableLoss) {
            this.refresh();
        }
    }

    async storeComments(action = undefined) {
        const commentsACRKey = this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId;

        const data = [
            {
                shortComment: this.shortComment || "",
                longComment: this.longComment || "",
                validated: this.validated,
            },
        ];

        const upsertVariables: any = {
            id: this.commentsACRId || "",
            key: commentsACRKey,
            companyId: this.companyId,
            status: this.validated ? "VALIDATED" : "EDITION",
            thirdPartyCompanyCreate: undefined,
            thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // deleteDocuments: [], // ** previous results, if to delete
            // documents: [],  // ** results = générés par le contrôle
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            auditCheckKey: this.acKey,
            data: data,
            type: "IN_AUDIT_REPORT",
            reviewed: this.reviewed,
        };

        // eslint-disable-next-line no-await-in-loop
        const resultUnrecoverableLoss: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        // await this.createUserActivity(action) // deprecated

        this.refresh();
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.generalLedger.setAllAccountableAccountsAsAudited();
            await this.storeComments("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.generalLedger.setAllAccountableAccountsAsUnaudited();
            await this.storeComments("UPDATE");
        }
    }

    onQueryDone411NL(data) {
        if (data.generalLedger?.length) {
            this.totalBalance411NL = -data.total411Balance;
            this.show411NL = true;
        } else {
            this.show411NL = false;
        }
    }

    onQueryDone411NLNextPeriod(data) {
        if (data.generalLedger?.length) {
            this.totalBalance411NLNextPeriod = -data.total411Balance;
            this.show411NLNextPeriod = true;
        } else {
            this.show411NLNextPeriod = false;
        }
    }

    onQueryDone4198NL(data) {
        if (data.generalLedger?.length) {
            this.totalBalance4198NL = mathFix(data.totalBalance, 2);
            this.show4198NL = true;
        } else {
            this.show4198NL = false;
        }
    }

    onQueryDone4198NLNextPeriod(data) {
        if (data.generalLedger?.length) {
            this.totalBalance4198NLNextPeriod = mathFix(data.totalBalance, 2);
            this.show4198NLNextPeriod = true;
        } else {
            this.show4198NLNextPeriod = false;
        }
    }

    sumsUnrecoverableLossDialogTable(manualKey, calculatedKey) {
        // sum data in give key (property)
        return (
            Object.values(this.vatBasis).reduce(
                (a, b) =>
                    a +
                    (manualKey && b[manualKey]
                        ? b[manualKey]
                        : calculatedKey && b[calculatedKey]
                          ? b[calculatedKey]
                          : 0),
                0,
            ) || 0
        );
    }

    sumsProvisionsTable() {
        const amounts = [];

        for (const item of this.provisionsList) {
            if (
                item.data &&
                item.data.accountingLines &&
                item.data.accountingLines[0] &&
                item.data.accountingLines[0].amountSigned
            ) {
                amounts.push(item.data.accountingLines[0].amountSigned);
            } else if (
                item.accountingLines &&
                item.accountingLines[0] &&
                item.accountingLines[0].amountSigned
            ) {
                amounts.push(item.accountingLines[0].amountSigned);
            }
        }

        const amountSigned = amounts.reduce((a, b) => a + b, 0);

        return amountSigned;
    }

    expandComment(item) {
        const index = this.expanded.findIndex((e) => e.customer.id === item.customer.id);
        if (index === -1) {
            this.expanded.push(item);
        } else {
            this.expanded.splice(index, 1);
        }
    }

    addComment(item) {
        const index = this.customers.findIndex((c) => c.customer.id === item.customer.id);
        if (index && index >= 0) {
            this.customers[index].comment = item.comment || "";
            this.createComments();
        }
    }

    createComments() {
        this.comments = [];

        for (const i of this.customers) {
            if (i.comment) {
                this.comments.push({
                    title: i.customer.name,
                    text: i.comment,
                });
            }
        }

        if (!this.comments.length) {
            this.comments.push({
                text: "Aucun commentaire saisi",
            });
        }
    }

    toArray(comment) {
        const carriedTexts = comment.split("\n");
        return carriedTexts;
    }

    async deleteAuditCheckResult(acrs) {
        if (acrs?.length) {
            const customerPeriodACR = acrs.find(
                (acr) =>
                    acr.acrKey.startsWith("k0WcnJvR7bjs1cDvpQ1qjpHnP") &&
                    acr.acrKey.includes(this.accountingPeriod.id) &&
                    acr.acrKey.includes(this.accountingPeriod.id),
            );

            if (customerPeriodACR) {
                const deletedAcr = await this.$apollo.mutate({
                    mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
                    variables: { id: customerPeriodACR?.acrId } || {},
                });

                if (deletedAcr) {
                    this.refresh();
                }
            }
        }
    }

    // **************** TABLE : creditNotes *****************
    async openCreditNotesList(data, customer) {
        if (this.creditNotesCustomer === customer) {
            this.expand4 = !this.expand4;
        } else {
            this.creditNotesCustomer = customer;
            if (this.customers.length > 0) {
                if (data) {
                    this.existingCreditNotes = data;
                }
            }
            this.expand4 = true;
        }
    }

    async initialiseCompany() {
        // this.currentDocACRid = ""
        // this.previousDocumentsIds = []
        this.loading = false;
        this.valid = false;
        this.valid2 = false;

        // this.expand = false;
        // this.expand2 = false;
        // this.expand3 = false;
        // this.expanded = []
        // this.commentsExpand = false

        // this.company = {};
        // this.withAccountingPeriod = false;
        // this.accountingPeriod = null
        this.periodYear = "";

        // ** customers
        this.selectedCustomer = {};

        // ** dialogs
        this.provisionsDialog = false;
        this.unrecoverableLossDialog = false;
        this.miscellaneousOperationDialog = false;

        // ** generalLedger
        this.totalBalance411NL = 0;
        this.totalBalance411NLNextPeriod = 0;
        this.totalBalance4198NL = 0;
        this.totalBalance4198NLNextPeriod = 0;

        // * dates
        this.minDate = this.accountingPeriod?.start
            ? this.formatDatePicker(this.accountingPeriod.start)
            : this.formatDatePicker(moment().format());
        this.maxDate = this.accountingPeriod?.end
            ? this.formatDatePicker(this.accountingPeriod.end)
            : this.formatDatePicker(moment().format());
        // this.selectedDate   // ** keep the value of this.selectedDate
        // this.dateProvision = moment().format()
        // this.dateUnrecoverableLoss = moment().format()

        // * sales documents
        this.invoicesToProvision = [];
        // this.invoicesNotToPay = []
        this.invoiceNumber = "";
        // this.selectedInvoices = []
        // this.singleSelect = true
        this.periodDocuments = [];
        this.selectedPeriod = "";
        this.periodsCustomer = {};

        // ** provisions
        this.provisionCustomer = {};
        // * percent
        this.cumulatedPercent = 0.0;
        this.newPercent = 0.0;
        this.deltaPercent = 0.0;
        // * amounts
        this.provision6Base = 0.0;
        this.cumulated4Provisions = 0.0;
        this.new4ProvisionAmount = 0.0;
        this.provisionReversal = 0.0;
        this.delta4ProvisionAmount = 0.0;
        this.provisionsList = {};
        this.provisionDocumentsAls = [];

        // ** unrecoverableLoss
        this.unrecoverableLossCustomer = {};
        this.unrecoverableLossNetAmount = 0.0;
        this.unrecoverableLossVatAmount = 0.0;
        this.unrecoverableLossGrossAmount = 0.0;
        this.unrecoverableLossList = [];
        this.unrecoverableLossDocumentsAls = [];
        this.manualExportNetAmountSigned = 0;

        this.vatAAs = await getVatAAs(this.$store.state.accountableAccountTable);
        this.vatBasis = JSON.parse(JSON.stringify(this.defaultVatBasis));
        for (const key in this.vatBasis) {
            const vatRate = this.vatBasis[key].vatRate;
            if (vatRate && vatRate > 0) {
                this.vatBasis[key].accountableAccountName = getAANameFromVatRate(
                    this.vatAAs,
                    "4457",
                    vatRate,
                );
            }
        }

        // ** acr
        this.acr = undefined;
        this.customerPeriodAcrKey = "";
        this.validatedCustomer = false;
        this.ignoredCustomer = false;
        this.switchManual = false;
        this.step = 1;
        this.stepUL = 1;
    }

    get computedHeaders() {
        let filteredHeaders = this.doubtfullAccountsHeaders;
        if (!this.switchPrevious) {
            filteredHeaders = this.doubtfullAccountsHeaders.filter(
                (h) =>
                    h.text != "AAE TTC déjà émis" &&
                    h.text != "HT" &&
                    h.text != "TVA" &&
                    h.text != "Créance TTC",
            );
        }
        if (!this.switchReceivableAgeing) {
            filteredHeaders = filteredHeaders.filter(
                (h) =>
                    !h.text.startsWith("<") && !h.text.startsWith(">") && !h.text.startsWith("de "),
            );
        }
        return filteredHeaders;
    }

    showProvision(customer) {
        if (
            customer.unrecoverableLoss?.cumulated4SignedAmount &&
            customer.basisGrossAmountSigned &&
            (customer.unrecoverableLoss.cumulated4SignedAmount - customer.basisGrossAmountSigned <
                1 ||
                customer.unrecoverableLoss.cumulated4SignedAmount -
                    customer.basisGrossAmountSigned >
                    -1)
            // ) && (
            //     !customer.doubtfulls?.cumulated4SignedAmount ||
            //     (
            //         customer.doubtfulls.cumulated4SignedAmount < 1 ||
            //         customer.doubtfulls.cumulated4SignedAmount > -1
            //     )
        ) {
            return false;
        }
        return true;
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
    }

    get disabledBtnGlobalValidation() {
        if (this.accountingPeriod?.closed) {
            return true;
        }

        if (this.customers?.length) {
            const notValidatedOrIgnoredCustomer = this.customers.some(
                (c) => !c.validated && !c.ignored,
            );
            if (notValidatedOrIgnoredCustomer) {
                if (this.validated) {
                    this.validated = false;
                    this.storeComments();
                }
                return true;
            }
        }
        return false;
    }

    showRow(propsItem) {
        if (!this.switchValidated && propsItem.validated) {
            return false;
        }
        if (!this.switchIgnored && propsItem.ignored) {
            return false;
        }
        if (!this.switchUnrecoverableLoss && this.fullUnrecoverableCustomer(propsItem)) {
            return false;
        }
        return true;
    }
}

export default toNative(CheckDoubtfullAccounts);
</script>
